export const jobs = {
  // The job page, top down (tracker sj-30).
  page: {
    state: {
      done: "Hecho",
      current: "Está aquí",
      upcoming: "Después",
    },
    youAreHere: "Está aquí",
    nextStep: {
      title: "Siguiente paso",
      needsYou: "Le necesita",
      changeStatusA11y: "Estado: {{status}}. Cambiar estado",
      giveToSomeoneElse: "Dárselo a otra persona",
      nothingLeft: "No queda nada por hacer",
    },
    section: {
      what: "Qué hacer",
      where: "Dónde",
      who: "Quién y cuándo",
      before: "Antes de empezar",
      beforeAny: "Antes de que empiece cualquier subtrabajo",
      work: "El trabajo",
      subJobs: "Subtrabajos",
      costs: "Costes",
      finish: "Al terminar",
      atTheEnd: "Al final",
      signOff: "Aprobación",
      report: "Informe",
      activity: "Actividad",
    },
    change: "Cambiar",
    openReport: "Abrir informe",
    meta: {
      doneOf: "{{done}} de {{total}}",
      updates_one: "1 actualización",
      updates_many: "{{count}} actualizaciones",
      updates_other: "{{count}} actualizaciones",
      estimate: "aprox. {{amount}}",
    },
    summary: {
      nobodyYet: "Nadie todavía",
      workDone: "Trabajo hecho",
      signedOff: "Aprobado",
      waitingSignOff: "Esperando aprobación",
      reportLater: "Listo cuando el trabajo esté hecho",
      costsLater: "Se añaden cuando empieza el trabajo",
      noCosts: "No se registraron costes",
      signOffLater: "Cuando el trabajo esté hecho",
    },
  },
  visits: {
    showMe: "Muéstrame",
    title: "Visitas",
    empty: "Una visita por ahora. Planifique otra si el trabajo necesita más de un día.",
    visitNo: "Visita {{no}}",
    arrive: "Ya estoy aquí",
    arrived: "Llegada registrada",
    move: "Mover la visita",
    moveTitle: "Mover la visita {{no}}",
    moved: "Visita movida",
    notes: "Notas del día",
    notesTitle: "Notas de la visita {{no}}",
    notesMessage: "¿Qué se hizo en esta visita?",
    notesSaved: "Notas guardadas",
    cancel: "Cancelar la visita",
    cancelled: "Visita cancelada",
    add: "Planificar una visita",
    addAnother: "Planificar otra visita",
    addTitle: "Planificar una visita",
    addHint: "La misma persona vuelve otro día. El trabajo se completa una sola vez, al final.",
    added: "Visita planificada",
    comeBack: "Necesito volver",
    comeBackTitle: "Necesito volver",
    comeBackHint: "La visita de hoy termina aquí y se planifica la siguiente. El trabajo sigue abierto.",
    comeBackReason: "¿Por qué necesita volver?",
    todayNotes: "Qué se hizo hoy (opcional)",
    nextDay: "Próxima visita",
    comeBackConfirm: "Planificar la próxima visita",
    comeBackSaved: "Próxima visita planificada",
    comeBackBecause: "Volverá: {{reason}}",
    day: "Día",
    time: "Hora",
    save: "Guardar",
    cancelSheet: "Cancelar",
    photosHint: "Añada las fotos de una visita a la actividad del trabajo ese mismo día.",
    failedTitle: "No se pudieron actualizar las visitas",
    failedBody: "Vuelva a intentarlo.",
    count_one: "{{count}} visita",
    count_many: "{{count}} visitas",
    count_other: "{{count}} visitas",
    status: {
      planned: "Planificada",
      arrived: "Aquí desde las {{time}}",
      done: "Hecha",
      cancelled: "Cancelada",
    },
  },
  subJobs: {
    title: "Subtrabajos",
    progress: "{{done}} de {{total}} hechos",
    toCheck: "{{n}} por revisar",
    empty: "Divida este trabajo en partes más pequeñas, cada una con su persona y su fecha. Este trabajo espera hasta que todas estén hechas.",
    add: "Añadir subtrabajo",
    inOrder: "Hacerlos en orden",
    partOf: "Parte de {{title}}",
    partOfUnknown: "Parte de un trabajo mayor",
    unassigned: "Sin asignar todavía",
    waiting: "Esperando al anterior",
    waitsFor: "Espera a que «{{title}}» termine primero.",
    cost: "Coste de los subtrabajos hasta ahora: {{amount}}",
    created: "Subtrabajo añadido",
    sheetTitle: "Añadir un subtrabajo",
    orderFailedTitle: "No se pudo cambiar el orden",
    orderFailedBody: "Compruebe su conexión e inténtelo de nuevo.",
    asOneJob: "Convertirlos en un trabajo con subtrabajos",
    asOneJobHint: "Un trabajo agrupa los {{n}}, cada uno con su persona y su fecha. Se cierra cuando todos estén hechos.",
    parentTitle: "Corregir hallazgos en {{asset}}",
    parentTitleNoAsset: "Corregir hallazgos de la inspección",
    parentBrief: "Agrupa {{n}} subtrabajos, uno por hallazgo. Espera hasta que todos estén hechos.",
    openBlocksComplete_one: "Queda 1 subtrabajo abierto. Termínelo o cancélelo antes de completar este trabajo.",
    openBlocksComplete_many: "Quedan {{count}} subtrabajos abiertos. Termínelos o cancélelos antes de completar este trabajo.",
    openBlocksComplete_other: "Quedan {{count}} subtrabajos abiertos. Termínelos o cancélelos antes de completar este trabajo.",
    family: {
      status: {
        cancelled: "Cancelado",
        signed_off: "Aprobado",
        needs_you: "Te necesita",
        ready_to_sign_off: "Listo para aprobar",
        in_progress: "En curso",
        scheduled: "Programado",
        waiting: "En espera",
      },
      needs: {
        over_budget: "Los costes de los subtrabajos superan el presupuesto del trabajo.",
        declined: "Se rechazó un subtrabajo. Asígnelo a otra persona para que el trabajo avance.",
        cant_complete: "Alguien no puede hacer su subtrabajo según lo programado. Decídalo en el subtrabajo.",
        sent_back: "Se devolvió un subtrabajo y se está rehaciendo.",
        late: "Un subtrabajo va con retraso. Recuérdelo, reasígnelo o muévalo.",
      },
      runBy: "Dirigido por {{name}}",
      runByNobody: "Nadie dirige este trabajo todavía",
      changeOwner: "Cambiar quién lo dirige",
      budget: "Presupuesto {{budget}} · hasta ahora {{spent}}",
      overBudget: "Supera el presupuesto en {{amount}}",
      forecast: "Fin previsto {{date}}",
      due: "Vence {{date}}",
      checked: "Revisado",
      needsCheck: "Hecho: revíselo",
      waitsForList: "Espera a {{titles}}",
      late: "Con retraso",
      showAll: "Mostrar los {{total}}",
      showFewer: "Mostrar menos",
      check: "Revisar el trabajo",
      checkedToast: "Trabajo revisado",
      youAreHere: "Está aquí",
      stepOf: "Subtrabajo {{n}} de {{total}}",
      previous: "Anterior",
      next: "Siguiente",
      menu: {
        title: "{{title}}",
        open: "Abrir",
        start: "Empezar",
        schedule: "Programar",
        reassign: "Reasignar",
        remind: "Recordar",
        pause: "Pausar",
        skip: "Omitir, con un motivo",
        check: "Revisar el trabajo",
        sendBack: "Devolver",
        askPhotos: "Pedir fotos",
        waitsFor: "A qué espera",
        separate: "Convertirlo en un trabajo aparte",
        moveTo: "Mover a otro trabajo",
        run: "Gestionar",
        review: "Revisar",
        family: "Trabajo",
      },
      reminded: "Recordatorio enviado",
      remindedAlready: "Nada que recordar: está terminado o no tiene a nadie asignado.",
      skipTitle: "¿Omitir este subtrabajo?",
      skipMessage: "Cuenta como hecho para el trabajo y nunca se muestra como trabajo realizado.",
      skipPlaceholder: "¿Por qué no hace falta?",
      skipConfirm: "Omitir",
      skipped: "Subtrabajo omitido",
      sendBackTitle: "Devolver",
      sendBackMessage: "Indique qué hay que rehacer. Se avisa a {{name}} y el trabajo se revisa de nuevo cuando esté terminado.",
      sendBackPlaceholder: "¿Qué hay que rehacer?",
      sendBackConfirm: "Devolver",
      sentBack: "Devuelto",
      askPhotosTitle: "Pedir fotos",
      askPhotosMessage: "Indique qué necesita ver. Sigue terminado mientras {{name}} las añade.",
      askPhotosPlaceholder: "¿Qué necesita ver?",
      askPhotosConfirm: "Pedir",
      asked: "Fotos pedidas",
      pausePlaceholder: "¿Por qué se pausa?",
      pauseTitle: "¿Pausar este subtrabajo?",
      pauseConfirm: "Pausar",
      paused: "En pausa",
      separateTitle: "¿Convertirlo en un trabajo aparte?",
      separateMessage: "Sale de este trabajo y conserva su persona, fechas e historial. Este trabajo ya no lo espera.",
      separateConfirm: "Separarlo",
      separated: "Ahora es un trabajo aparte",
      signOff: "Aprobar todo el trabajo",
      signOffHint_one: "Aprueba este trabajo y su subtrabajo terminado a la vez.",
      signOffHint_many: "Aprueba este trabajo y sus {{count}} subtrabajos terminados a la vez.",
      signOffHint_other: "Aprueba este trabajo y sus {{count}} subtrabajos terminados a la vez.",
      signOffFor: "Listo para que {{name}} lo apruebe.",
      signedOff: "Trabajo aprobado",
      approvalEach: "Reviso cada subtrabajo cuando termina",
      approvalEachHint: "El siguiente empieza solo después de su revisión. Desactivado: el aprobador revisa todo una vez, al aprobar.",
      moveAll: "Mover todas las fechas",
      moveAllTitle: "Mover los subtrabajos abiertos",
      moveAllMessage: "¿Cuántos días? Ponga un signo menos para adelantarlos.",
      moveAllConfirm: "Mover",
      movedDates_one: "1 subtrabajo movido",
      movedDates_many: "{{count}} subtrabajos movidos",
      movedDates_other: "{{count}} subtrabajos movidos",
      moveDaysInvalid: "Escriba un número entero de días, como 2 o -1.",
      cancelAll: "Cancelar todo el trabajo",
      cancelAllTitle: "¿Cancelar todo el trabajo?",
      cancelAllMessage: "Se cancelan el trabajo y todos los subtrabajos aún sin terminar, y se avisa a sus personas. El trabajo terminado conserva su registro.",
      cancelAllPlaceholder: "¿Por qué? (opcional)",
      cancelAllConfirm: "Cancelar el trabajo",
      cancelledAll_one: "Trabajo cancelado con 1 subtrabajo abierto",
      cancelledAll_many: "Trabajo cancelado con {{count}} subtrabajos abiertos",
      cancelledAll_other: "Trabajo cancelado con {{count}} subtrabajos abiertos",
      more: "Más para este trabajo",
      failedTitle: "No se pudo hacer",
      failedBody: "Compruebe la conexión e inténtelo de nuevo.",
      waitsForTitle: "¿A qué espera «{{title}}»?",
      waitsForNone: "A nada: puede empezar cuando sea",
      waitsForSaved: "Guardado",
      addExisting: "Añadir un trabajo existente",
      addExistingTitle: "Añadir un trabajo existente",
      addExistingEmpty: "No hay ningún trabajo abierto en este emplazamiento que se pueda añadir.",
      added: "Añadido a este trabajo",
      moveToTitle: "¿A qué trabajo moverlo?",
      moveToEmpty: "No hay otro trabajo abierto en este emplazamiento.",
      movedTo: "Movido",
      planTitle: "Planificar los subtrabajos",
      planHint: "El trabajo en sí se hace en los subtrabajos. Este trabajo se cierra cuando todos están hechos{{checked}}.",
      planHintChecked: " y revisados",
      slipTitle_one: "¿Mover el subtrabajo que espera a este?",
      slipTitle_many: "¿Mover los {{count}} subtrabajos que esperan a este?",
      slipTitle_other: "¿Mover los {{count}} subtrabajos que esperan a este?",
      slipMessage_one: "Este se movió 1 día {{direction}}. Muévalos lo mismo para que se mantenga el orden.",
      slipMessage_many: "Este se movió {{count}} días {{direction}}. Muévalos lo mismo para que se mantenga el orden.",
      slipMessage_other: "Este se movió {{count}} días {{direction}}. Muévalos lo mismo para que se mantenga el orden.",
      later: "más tarde",
      earlier: "antes",
      budgetSet: "Fijar un presupuesto",
      budgetMessage: "Los costes de los subtrabajos cuentan contra él; se le avisa cuando se supera. Escriba 0 para quitarlo.",
      budgetConfirm: "Guardar",
      budgetInvalid: "Escriba un importe, como 2500.",
      budgetSaved: "Presupuesto guardado",
      timeline: {
        today: "Hoy",
        forecast: "Fin previsto",
        undated_one: "1 subtrabajo aún no tiene fecha",
        undated_many: "{{count}} subtrabajos aún no tienen fecha",
        undated_other: "{{count}} subtrabajos aún no tienen fecha",
      },
      activityFromSubJobs: "De los subtrabajos",
      activityLabel: "Subtrabajo {{n}}: {{title}}",
      addToThisJob: "Añadir a este trabajo",
      separateJob: "Trabajo aparte",
      addedToThisJob: "Añadido como siguiente subtrabajo",
      extraWaiting: "Trabajo extra pendiente de tu decisión: {{title}}",
      sentToRequester: "Enviado al solicitante para que lo confirme. Fírmalo cuando lo acepte.",
      waitsForRequester: "El solicitante confirma primero todo el trabajo y después lo firmas tú.",
      template: {
        use: "Añadir subtrabajos desde una plantilla",
        save: "Guardar como plantilla",
        saveMessage: "Guarda estos subtrabajos, su orden y qué espera a qué. No se guardan personas, fechas ni costes.",
        saveConfirm: "Guardar plantilla",
        saved: "Guardada como «{{name}}»",
        pickTitle: "Plantillas",
        manage: "Gestionar",
        delete: "Eliminar «{{name}}»",
        deleted: "Plantilla eliminada",
        empty: "Aún no hay plantillas. Guarda primero un trabajo con subtrabajos como plantilla.",
        row_one: "{{name}} · 1 paso",
        row_many: "{{name}} · {{count}} pasos",
        row_other: "{{name}} · {{count}} pasos",
        applied_one: "1 subtrabajo añadido",
        applied_many: "{{count}} subtrabajos añadidos",
        applied_other: "{{count}} subtrabajos añadidos",
      },
      showMe: "Muéstrame",
      mainContractor: {
        handOver: "Encargar a un contratista principal",
        takeBack: "Recuperar el trabajo",
        takeBackTitle: "¿Recuperar el trabajo?",
        takeBackMessage: "{{name}} deja de dirigir este trabajo y lo vuelve a dirigir usted. Los subtrabajos ya asignados siguen con quien los tiene.",
        takenBack: "Vuelve a dirigir este trabajo",
        pickTitle: "¿Qué contratista dirige este trabajo?",
        allowTitle: "¿Puede {{name}} usar también sus contratistas?",
        allowYes: "Sí, puede dar subtrabajos a nuestros contratistas",
        allowNo: "No, solo su propio personal",
        handedOver: "{{name}} dirige ahora este trabajo",
        youRunIt: "Dirige este trabajo para el cliente. Añada subtrabajos para su equipo; el cliente da la conformidad al final.",
        runsIt: "Un contratista principal dirige este trabajo. Usted da la conformidad al final.",
        nameCrew: "Nombrar el equipo",
        nameCrewMessage: "¿Quién de su equipo hace este subtrabajo? El cliente ve el nombre.",
        nameCrewConfirm: "Guardar",
        crewSaved: "Equipo guardado",
        crewPlaceholder: "Por ejemplo: Lee",
        subJobTitle: "Qué hay que hacer",
        brief: "Descripción (opcional)",
        when: "Cuándo",
        who: "Quién lo hace",
        ourCrew: "Nuestro equipo",
        crewName: "Equipo o persona",
        clientContractorHint: "El contratista del cliente recibe el subtrabajo y sus propios recordatorios.",
        addAnother: "Añadir y siguiente",
      },
      report: {
        summary: "Resumen",
        full: "Completo",
        internal: "Interno",
        forClient: "Para el cliente",
        forClientHint: "Para el cliente: sin tarifas ni precios de contratistas.",
        partOf: "Parte de",
        checked: "Revisado",
        checkedBy: "Revisado por {{name}}",
        started: "Empezado {{date}}",
        finished: "Terminado {{date}}",
        evidence_one: "1 foto o archivo",
        evidence_many: "{{count}} fotos o archivos",
        evidence_other: "{{count}} fotos o archivos",
      },
      parts: {
        title: "Piezas de todo el trabajo",
        missing_one: "1 sin conseguir",
        missing_many: "{{count}} sin conseguir",
        missing_other: "{{count}} sin conseguir",
        allInHand: "Todo disponible",
        holdsUp: "Retrasa {{title}}",
      },
      plan: {
        asset: "Activo",
        priority: "Prioridad",
        estimate: "Estimación",
        minutes: "Duración (minutos)",
        waitsFor: "Espera a",
        copyFrom: "Copiar de un trabajo anterior",
        addAnother: "Añadir y otro más",
        create: "Crear subtrabajo",
        minutesOther: "Otra duración (minutos)",
        done: "Listo",
        addedCount_one: "1 subtrabajo añadido",
        addedCount_many: "{{count}} subtrabajos añadidos",
        addedCount_other: "{{count}} subtrabajos añadidos",
      },
      setup: {
        title: "¿Quién dirige este trabajo?",
        hint: "Quien lo dirige planifica los subtrabajos, revisa cada uno cuando termina y mantiene el trabajo en marcha.",
        me: "Yo",
        current: "{{name}} (lo tiene ahora)",
        someoneElse: "Otra persona",
        keepOwnWork: "Mantener el trabajo que ya tiene este trabajo como subtrabajo 1",
        keepOwnWorkHint: "{{name}} conserva ese trabajo y se le pide que lo acepte de nuevo como subtrabajo.",
        continue: "Continuar",
      },
    },
  },
detail: {
  handoffLock: {
    assignee: "Entregada a {{name}}. La orden se mantiene como se definió; reasígnala o recupérala para cambiarla.",
    quotes: "Con contratistas para presupuestar. La orden se mantiene como se definió; elige un presupuesto o cierra la solicitud para cambiarla.",
    changeTheWork: "Cambiar el trabajo",
    changing: "Estás cambiando esta orden. {{name}} ha sido avisado y se le pedirá que la acepte de nuevo cuando termines.",
    doneChanging: "Terminar el cambio",
    beingChangedBy: "{{name}} está cambiando esta orden.",
    changedSinceAccepted: "Esta orden cambió desde que la aceptaste. Revísala y acéptala de nuevo.",
    revisedLength: "¿Cuánto tardará ahora? (minutos)",
    opened: "Cambio abierto. {{name}} ha sido avisado.",
    closed: "Cambio cerrado. Se ha pedido a {{name}} que acepte el trabajo revisado.",
  },
  report: {
    sharePrepared: "{{title}} está listo.",
    shareSheetProviderHint: "Elige {{provider}} en el menú de compartir para guardar este archivo.",
    share: {
      word: "Compartir Word…",
      excel: "Compartir Excel…",
      pdf: "Compartir PDF…",
    },
    requestFailed: "No funcionó. Comprueba tu conexión e inténtalo de nuevo.",
    exportFailed: "No se pudo crear el archivo del informe. Comprueba tu conexión e inténtalo de nuevo.",
    exportShared: "Informe listo. Se abrió el menú de compartir para guardarlo o enviarlo.",
    exportDownloadStarted: "La descarga ha empezado. La encontrarás en tus descargas.",
    exportTitle: "Informe final del trabajo ({{format}})",
    brandingSettings: "Ajustes de marca",
    openJob: "Abrir trabajo",
    linkCopied: "Enlace de revisión copiado. Pégalo en un correo o mensaje.",
    shareToGetLink: "Comparte el informe para obtener un enlace",
    copyReviewLink: "Copiar enlace de revisión",
    reviewRequested: "revisión solicitada",
    sharedWith: "Compartido con {{name}}",
    sharedReport: "Informe final compartido",
    signedBy: "Firmado por {{name}}",
    forYourRecords: "Este informe es para tus registros.",
    alreadyClosed: "Este trabajo ya está cerrado.",
    sentBackMessage: "Devolviste el trabajo. El equipo lo arreglará y volverá a compartir el informe.",
    acceptedThanks: "Aceptaste el trabajo. Gracias.",
    acceptedTeamCloses: "Aceptaste el trabajo. Ahora el equipo cerrará la orden de trabajo.",
    sendBack: "Devolver",
    acceptWork: "Dar conformidad",
    signOffPrompt: "Revisa el trabajo de arriba. Si estás conforme, firma para dar conformidad. Si no, toca Devolver y di qué hay que arreglar.",
    decisionFailedBody: "Comprueba tu conexión e inténtalo de nuevo.",
    decisionFailedTitle: "Tu respuesta no se envió",
    sentBackToast: "Devuelto. Se ha avisado al equipo de lo que hay que arreglar.",
    acceptedToast: "Gracias. Se ha avisado al equipo de que estás conforme con el trabajo.",
  },
  contextCard: {
    untitledJob: "Trabajo sin título",
    created: "Creado",
    createdBy: "Creado por {{name}}",
    showFewerDetails: "Mostrar menos detalles",
    showMoreDetails: "Mostrar más detalles",
    fewerDetails: "Menos detalles",
    moreDetails: "Más detalles",
    dueAndScheduled: "Para el {{due}} · programado el {{scheduled}}",
    scheduled: "Programado el {{scheduled}}",
    due: "Para el {{due}}",
    contacts: "Contactos",
    when: "Cuándo",
    why: "Por qué",
    what: "Qué",
    where: "Dónde",
    asset: "Activo",
  },
  actionSheets: {
    failedToAskForPhotos: "Tu petición de fotos no se envió. Comprueba tu conexión e inténtalo de nuevo.",
    failedToSendBack: "El trabajo no se devolvió. Comprueba tu conexión e inténtalo de nuevo.",
    failedToDecline: "El trabajo no se rechazó. Comprueba tu conexión e inténtalo de nuevo.",
    failedToCancel: "El trabajo no se canceló. Comprueba tu conexión e inténtalo de nuevo.",
    failedToPause: "El trabajo no se pausó. Comprueba tu conexión e inténtalo de nuevo.",
    askedForPhotosUnnamed: "Se pidieron más fotos. El trabajo espera tu revisión.",
    askedForPhotos: "Se pidieron más fotos a {{assignee}}. El trabajo espera tu revisión.",
    sentBackUnnamed: "Devuelto con tu nota. Se te avisará cuando se vuelva a enviar.",
    sentBack: "Devuelto a {{assignee}} con tu nota. Se te avisará cuando lo vuelva a enviar.",
    declined: "Trabajo rechazado. Se ha avisado a quien lo asignó y puede reasignarlo.",
    cancelled: "Trabajo cancelado. Queda en el historial.",
    paused: "Trabajo en pausa. Toca Reanudar cuando se pueda seguir.",
  },
  fieldAssist: {
    failedTitle: "No se pudo mejorar el texto",
    revert: "Deshacer",
    discard: "Descartar",
    accept: "Aceptar",
    rationale: "Revisa el texto y toca Aceptar. Tu texto se mantiene hasta entonces.",
    draftTitle: "Texto mejorado",
    tidying: "Mejorando…",
    tidyUp: "Mejorar con IA",
    stop: "Detener",
    dictate: "Dictar",
  },
  deliveryMode: {
    hint: {
      PRIVATE_QUOTES: "Pide precio a varios contratistas y elige uno.",
      DIRECT_CONTRACTOR: "Envíalo a un contratista con el que ya trabajas.",
      INTERNAL: "Alguien de tu equipo hace el trabajo.",
    },
    label: {
      PRIVATE_QUOTES: "Pedir presupuestos",
      DIRECT_CONTRACTOR: "Un contratista",
      INTERNAL: "Nuestro equipo",
    },
    title: "¿Quién lo hace?",
  },
title: "Orden de trabajo",
actionModals: {
  send: "Enviar",
pauseReasons: {
waitingOnParts: "Esperando piezas",
weatherDelay: "Retraso por clima",
customerRequest: "Solicitud del cliente",
other: "Otro",
},
declineReasons: {
scheduleConflict: "Conflicto de programación",
noCapacity: "Demasiado ocupado ahora",
wrongTrade: "Requiere otra especialidad",
needMoreInfo: "Necesita más información",
},
pauseTitle: "Pausar orden de trabajo",
pauseReasonRequiredHint: "Se requiere un motivo para que el equipo sepa por qué el trabajo está en espera.",
additionalDetailOptional: "Detalle adicional (opcional)",
additionalDetailPlaceholder: "por ej. Se espera que vuelva a estar disponible la próxima semana.",
cancel: "Cancelar",
pause: "Pausar",
cancelJobTitle: "Cancelar orden de trabajo",
cancelJobConfirm: "¿Seguro? Esta acción no se puede deshacer.",
reasonOptional: "Motivo (opcional)",
cancellationReasonPlaceholder: "por ej. Ya no es necesario",
back: "Atrás",
yesCancel: "Sí, cancelar",
declineJobTitle: "Rechazar trabajo",
declineReasonRequiredHint: "Se requiere un motivo. Se notificará a la persona que asignó esta orden de trabajo.",
reasonRequired: "Motivo (obligatorio)",
declineReasonPlaceholder: "por ej. Conflicto de horarios, capacidad, otros compromisos",
additionalNoteOptional: "Nota adicional (opcional)",
additionalNotePlaceholder: "Cualquier detalle para la persona que lo asignó",
declineJob: "Rechazar",
reworkTitle: "Devolver",
reworkHint: "Di qué hay que arreglar. Quien hizo el trabajo verá tu nota y lo volverá a enviar para revisión cuando esté arreglado.",
reworkReasonPlaceholder: "por ej. Faltan fotos para X, costo real no completado, notas poco claras",
evidenceTitle: "Pedir fotos",
evidenceHint: "Di qué necesitas ver. El trabajo sigue pendiente de tu revisión mientras añaden las fotos.",
evidenceReasonPlaceholder: "p. ej. Una foto clara de la zona de montaje inferior",
requestEvidence: "Pedir fotos",
rework: "Devolver",
},
detailScreen: {
  followUpNeeded: "Hace falta seguimiento: {{reason}}.",
  receiptsAndInvoices: "Recibos y facturas",
  verifyInTheirPlace: "Verificar en su lugar",
  completedSolo: "Hecho. El trabajo está cerrado.",
  assignedInviteFailedBody: "El trabajo es suyo, pero no se pudo enviar el correo de invitación. Avísale tú.",
  assignedInviteFailedTitle: "Asignado, pero el correo no se envió",
  noTeamBody: "No se pudo saber a qué equipo pertenece este trabajo, así que no se invitó al contratista. Comprueba tu conexión e inténtalo de nuevo.",
  noTeamTitle: "Este trabajo no tiene equipo",
  failedToResume: "El trabajo no se reanudó. Comprueba tu conexión e inténtalo de nuevo.",
  failedToAssign: "El trabajo no se asignó. Comprueba tu conexión e inténtalo de nuevo.",
addTitleFirst: "Agregue un título primero",
addDescriptionFirst: "Agregue una descripción primero",
typeOrDictateTitleHint: "Escriba o dicte un título breve y luego use Mejorar con IA.",
typeOrDictateDescriptionHint: "Escriba o dicte una descripción y luego utilice Mejorar con IA.",
unableToImproveText: "No se puede mejorar el texto",
tryAgain: "Inténtelo de nuevo.",
verifiedInPlaceOf: "Verificado en lugar de {{name}}",
couldNotVerify: "No se pudo verificar",
tryAgainShort: "Inténtalo de nuevo.",
stageAdded: "{{stage}} añadido",
couldNotAddCheck: "No se pudo añadir esa comprobación",
precheckFirst: "Verificación previa primero",
notNow: "Ahora no",
runStage: "Ejecutar {{stage}}",
couldNotStartJob: "No se pudo iniciar esta orden de trabajo",
movedToStatus: "movido a {{status}}",
couldNotMoveJob: "No se pudo mover esta orden de trabajo",
acceptedOn: "Aceptado el",
rejectedOn: "Rechazado el",
sentToLine: "Enviado a {{names}}.",
missingEmailForLine: "Falta correo electrónico para {{names}}.",
noInvoiceOrReceiptAttached: "No se adjuntaron archivos de factura o recibo.",
completionSentTitle: "Finalización enviada",
completionEmailSent: "Correo electrónico de finalización enviado.",
emailNotSentTitle: "Correo electrónico no enviado",
visitConfirmed: "Visita confirmada",
awaitingVisitConfirmation: "Pendiente de confirmación de visita",
recipientLine: "{{label}}: {{name}}",
recipientEmailSuffix: " ({{email}})",
requesterDeliveryLine: "Solicitante: {{status}}",
assigneeDeliveryLine: "Responsable: {{status}}",
helpMeWithJobDraft: "Ayúdame con esta orden de trabajo: {{title}}. Sugiera los próximos pasos o un borrador de cierre.",
currentJobFallback: "Orden de trabajo actual",
captureNotSavedTitle: "Captura no guardada",
captureNotFoundBody: "No se pudo encontrar esa captura. Vuelve a capturarla.",
captureMismatchBody: "Esta captura no coincide con la orden de trabajo actual.",
noPhotoWasCaptured: "No se capturó ninguna foto.",
mustBeSignedInToSavePhotos: "Debes iniciar sesión para guardar fotos.",
capturedFromHome: "Capturado desde Inicio",
photoAddedToActivity: "Foto agregada a la actividad de la orden de trabajo.",
noDictationTextCaptured: "No se capturó ningún texto de dictado.",
jobUpdateAdded: "Actualización publicada. Todos en este trabajo la ven en Actividad.",
noNoteTextCaptured: "No se capturó ningún texto de nota.",
activityNoteAdded: "Nota añadida. Todos en este trabajo la ven en Actividad.",
readingCostNotePrefix: "Nota de lectura/coste: {{value}}",
readingAddedToActivity: "Lectura añadida a la actividad de la orden de trabajo",
captureNotSupportedTitle: "Captura no compatible",
qrScanNotSavedBody: "QR se maneja desde el escáner, no se guarda en la actividad de la orden de trabajo.",
captureModeNotSupported: "Este modo de captura no es compatible con las órdenes de trabajo.",
skillsUnavailableTitle: "Habilidades no disponibles",
skillsUnavailableBody: "No se pudieron cargar habilidades en este momento. Puedes volver a intentarlo en el selector.",
followOnTitleSuffix: "{{title}} (seguimiento)",
workFallback: "Trabajo",
revisedWorkSubmitted: "Trabajo corregido enviado para revisión. Se ha avisado al revisor.",
completionSubmittedAwaitingVerification: "Enviado para revisión. El revisor lo comprueba y lo verifica o lo devuelve.",
unableToCleanUp: "No se puede limpiar",
changeApproved: "Cambio aprobado. El trabajo muestra la nueva fecha o persona y se ha avisado a quien lo pidió.",
requestRejected: "Solicitud rechazada. El trabajo sigue igual y se ha avisado a quien lo pidió.",
error: "Algo salió mal",
couldNotRecordDecision: "Tu decisión no se guardó. Comprueba tu conexión e inténtalo de nuevo.",
savedOnDeviceWillSend: "Guardado en este dispositivo: se enviará cuando vuelva a estar en línea",
requestSent: "Solicitud enviada. Nada cambia hasta que la persona responsable la apruebe; se te avisará.",
couldNotSendRequest: "Tu solicitud no se envió. Comprueba tu conexión e inténtalo de nuevo.",
outcomeLinePrefix: "Resultado: {{value}}",
meterReadingTitle: "Lectura del medidor",
enterMeterReadingBody: "Ingrese la lectura del medidor como un número o déjelo en blanco.",
readingLowerThanCurrentBody: "{{amount}} es inferior al {{current}} actual. Verifique el número o registre una corrección de la tarjeta de Mantenimiento del activo.",
readingLowerThanEarlierBody: "Esta lectura es más baja que una anterior. Comprueba el número.",
readingAlreadyRecordedAfterBody: "Ya está registrada una lectura de {{current}} después de esta. Comprueba el número.",
laterReadingAlreadyRecordedBody: "Ya se ha registrado una lectura posterior. Comprueba el número.",
meterReadsInUnitBody: "Este contador mide en {{unit}}.",
completionSubmittedAwaitingOwnerVerification: "Enviado para revisión. Quien creó el trabajo lo revisa y lo verifica o lo devuelve.",
failedToComplete: "El trabajo no se envió. Tus notas y fotos se conservan. Comprueba tu conexión e inténtalo de nuevo.",
completeRequiredDetailsFirstTitle: "Primero complete los detalles requeridos",
pleaseFixBeforeSubmitting: "Corrija estos problemas antes de completar el envío:\n{{list}}",
goToCompletion: "Ir a finalización",
cancel: "Cancelar",
costBreakdownActionUnavailable: "La acción de desglose de costos no está disponible. Actualice la aplicación.",
jobAccepted: "Trabajo aceptado. Toca Iniciar cuando empieces.",
failedToAccept: "El trabajo no se aceptó. Comprueba tu conexión e inténtalo de nuevo.",
workApproved: "Trabajo verificado. El trabajo está cerrado y el historial del activo se ha actualizado.",
requireSignOffForJobsThisSize: "Requerir aprobación para órdenes de trabajo de este tamaño",
failedToApprove: "El trabajo no se verificó. Comprueba tu conexión e inténtalo de nuevo.",
cannotCreateCertificateTitle: "No se puede crear el certificado",
cannotCreateCertificateBody: "Esta orden de trabajo no está vinculada a ningún activo.",
certificateCreatedTitle: "Certificado creado",
certificateCreatedBody: "El certificado está vinculado a esta orden de trabajo y activo.",
couldNotCreateCertificate: "No se pudo crear el certificado.",
deleteJobTitle: "Eliminar orden de trabajo",
actionCannotBeUndone: "Esta acción no se puede deshacer.",
delete: "Eliminar",
jobDeleted: "Orden de trabajo eliminada",
failedToDelete: "El trabajo no se eliminó. Comprueba tu conexión e inténtalo de nuevo.",
titleRequiredTitle: "Título requerido",
enterFollowOnTitleBody: "Escribe un título para el trabajo de seguimiento.",
skillsRequiredTitle: "Habilidades requeridas",
selectRequiredSkillBody: "Elige al menos una habilidad para este trabajo de seguimiento.",
followUpJobCreated: "Orden de trabajo de seguimiento creada. Está en Trabajo y vinculada a esta orden de trabajo.",
followUpCreatedTitle: "Seguimiento creado",
followUpCreatedBody: "Se creó la orden de trabajo de seguimiento vinculada. Puede abrirla desde Finalización o seguir completando esta orden de trabajo.",
failedToCreateFollowOn: "El trabajo de seguimiento no se creó. Comprueba tu conexión e inténtalo de nuevo.",
failedToApproveFollowOn: "El seguimiento no se aprobó. Comprueba tu conexión e inténtalo de nuevo.",
notApproved: "No aprobado",
followUpNotApproved: "Seguimiento rechazado. Queda cancelado y tu motivo figura en su historial.",
failedToRejectFollowOn: "El seguimiento no se rechazó. Comprueba tu conexión e inténtalo de nuevo.",
linkAContact: "Vincular un contacto",
requesterFallback: "Solicitante",
draftCloseout: "Redactar la nota con IA",
draftInvoice: "Borrador de factura",
loadingJobDetails: "Cargando detalles de la orden de trabajo...",
unableToLoadJob: "No se puede cargar la orden de trabajo",
jobNotFound: "Orden de trabajo no encontrada",
ownerFallback: "Propietario",
parentJobApproverFallback: "Aprobador de la orden de trabajo principal",
assigneeFallback: "Responsable",
everyoneDeclinedYouInviteMore: "Todos los invitados rechazaron: invitas a más",
everyoneDeclined: "Todos los invitados rechazaron",
contractorsSubmitQuotes: "Los contratistas envían presupuestos",
youRequestQuotes: "Solicitas presupuestos",
ownerRequestsQuotes: "El propietario solicita presupuestos",
youPickAContractor: "Tú eliges un contratista",
ownerPicksAContractor: "El propietario elige un contratista",
youAssignTheJob: "Asignas la orden de trabajo",
ownerAssignsTheJob: "El propietario asigna la orden de trabajo.",
requesterConfirmsFixNamed: "{{name}} confirma la solución",
assignedPrefix: "Asignado",
assignedToSuffix: " a {{name}}",
resolveBeforeSubmitting: "Resuelva esto antes de enviar la finalización.",
tightenEvidenceCostsNotes: "Ajuste las pruebas, los costos o las notas para que la aprobación sea sencilla.",
captureFollowUpWorkHint: "Capture el trabajo de seguimiento o una orden de trabajo vinculada para que nada se escape.",
noScheduledStartExplanation: "Esta orden de trabajo no tiene un inicio programado.",
setScheduleRecommendedAction: "Aún sin fecha. Elige una fecha o asígnalo para que no se retrase.",
pastScheduledStartExplanation: "Esta orden de trabajo ya pasó su fecha de inicio o vencimiento programada.",
updateScheduleRecommendedAction: "Ya pasó la fecha. Reprográmalo o avisa al solicitante.",
completionChecksClear: "Las comprobaciones de finalización parecen claras para el registro actual.",
keepUpdatesAlignedAction: "Mantenga las actualizaciones, las pruebas, los costos y las notas alineados a medida que avanza el trabajo.",
reviewCompletion: "Revisar finalización",
openCompletion: "Abrir finalización",
setSchedule: "Establecer programación",
updateSchedule: "Actualizar programación",
inspectionLine: "Inspección: {{label}}",
openRelatedAsset: "Abrir activo relacionado",
jobInsight: "Información sobre la orden de trabajo",
insightWarnings_one: "{{count}} advertencia",
insightWarnings_many: "{{count}} advertencias",
insightWarnings_other: "{{count}} advertencias",
insightBlockers_one: "{{count}} bloqueo",
insightBlockers_many: "{{count}} bloqueos",
insightBlockers_other: "{{count}} bloqueos",
insightSummaryLine: "{{warnings}}, {{blockers}}",
followUp: "Seguimiento",
suggested: "Sugerido",
thisJobsChecksAndStatus: "comprobaciones y estado de esta orden de trabajo",
contractorWorkspace: "Espacio de contratista",
nextLine: "Siguiente: {{value}}",
statusUnavailable: "Estado no disponible",
updatesNew: "Actualizaciones · nuevas",
updates: "Actualizaciones",
hideStatusHistory: "Ocultar historial de estado",
statusHistory: "Historial de estado",
hideCompletionAndCosts: "Ocultar finalización y costos",
completionAndCosts: "Finalización y costos",
cancelJob: "Cancelar orden de trabajo",
deleteJobAction: "Eliminar orden de trabajo",
moreJobOptions: "Más opciones de órdenes de trabajo",
approveCompletion: "Verificar",
cantDoThis: "Rechazar",
assignDirectly: "Asignar directamente",
jobAssistant: "Asistente de orden de trabajo",
readOnly: "Sólo lectura",
jobCreated: "Trabajo creado",
suggestedNextStepLine: "Siguiente paso sugerido: {{step}}.",
trackProgressHint: "Realice un seguimiento del progreso en Actividad y luego ciérrelo cuando se complete el trabajo.",
dismissJobCreatedMessage: "Descartar mensaje de orden de trabajo creada",
gotIt: "Entendido",
atAGlance: "De un vistazo",
status: "Estado",
next: "Siguiente",
visit: "Visita",
cost: "Coste",
openAssetLabel: "Abrir activo {{name}}",
relatedRecords: "Registros relacionados",
couldNotSaveJobDetails: "No se pudieron guardar los detalles de la orden de trabajo.",
jobOptions: "Opciones de la orden de trabajo",
linkContactToJob: "Vincular contacto a orden de trabajo",
relationship: "Relación",
couldNotAddExtractedLineItem: "No se pudo agregar la línea de pedido extraída",
jobFallback: "Trabajo",
signInRequiredToUpload: "Es necesario iniciar sesión para cargar.",
reopenJob: "Reabrir orden de trabajo",
startJob: "Iniciar orden de trabajo",
acceptJob: "Aceptar orden de trabajo",
workPath: "Quién lo hace",
overdue: "Vencido",
unscheduled: "Sin programar",
onSiteLine: "En el sitio: {{location}}",
fromInspectionLine: "De la inspección — {{label}}",
followOnOfLine: "Seguimiento de — {{title}}",
parentJobFallback: "orden de trabajo principal",
requestedByLine: "Solicitado por — {{name}}",
roleAndNameLine: "{{role}} — {{name}}",
jobAssigned: "Trabajo asignado. Se le ha avisado y debe aceptarlo.",
contractorAssigned: "Contratista asignado. Se le ha enviado una invitación y debe aceptar el trabajo.",
jobResumed: "Trabajo reanudado. Toca Completar cuando termines.",
},
closeout: {
  extractLineItems: "Leer artículos de la factura",
  extractingLineItems: "Leyendo la factura…",
  generatingInvoice: "Creando la factura…",
  materialsSummary: "Añade piezas y materiales. Los sumaremos para la factura.",
followUpTitle: "Seguimiento",
suggestFollowUpWork: "Sugerir trabajo de seguimiento",
suggestNextSteps: "Sugerir próximos pasos",
apply: "Aplicar",
skillLine: "Habilidad: {{value}}",
riskLine: "Riesgo: {{value}}",
costsAndInvoicesIncluded: ". Los costos y facturas se incluyen a continuación.",
completedThisLine: "{{name}} lo completó{{when}}. ",
requesterConfirmsFix: "El solicitante confirma la solución",
ownerFallback: "Propietario",
addDetailsBeforeSubmitting: "Añade los detalles de finalización antes de enviar.",
submitCompletion: "Enviar finalización",
completion: "Finalización",
followUpJobsTitle: "Órdenes de trabajo de seguimiento",
followUpJobsSummary: "Añade o revisa trabajos de seguimiento cuando la nota final esté lista.",
proposeFollowOnJob: "Proponer un trabajo de seguimiento",
linkedHeldForApproval: "Vinculado a esta orden de trabajo y retenido para aprobación.",
proposeMoreWork: "Proponer más trabajo",
proposeMoreWorkHint: "Les llega como una solicitud. Ellos deciden y aquí ves la respuesta.",
proposalSent: "Propuesta enviada",
proposalWaiting: "Pendiente de decisión",
proposalApproved: "Aprobada",
proposalBecameJob: "Se convirtió en trabajo",
proposalNotTaken: "No se ha aceptado",
followUpJobsLinkedTitle: "Órdenes de trabajo de seguimiento vinculadas",
createdNowPrefix: "Creado ahora: ",
followUpPrefix: "Seguimiento: ",
pendingApprovalSuffix: " · Pendiente de aprobación",
followUpLinkedContinueBody: "El trabajo de seguimiento está vinculado. Puedes seguir y completar este trabajo.",
requiredBeforeSubmit: "Requerido antes de enviar",
beforeYouSubmit: "Antes de enviar",
workCompleted: "Trabajo completado",
workCompletedPlaceholder: "¿Qué trabajo se completó?",
rewriting: "Mejorando…",
rewrite: "Mejorar con IA",
revert: "Revertir",
actualCost: "Costo real",
leaveBlankToRecordAsZero: "Déjelo en blanco para registrarlo como 0. Ingrese el monto total de esta orden de trabajo si hubo un cargo.",
fromCostBreakdownReadOnly: "Del desglose de costos (solo lectura)",
verifiedLine: "Verificado {{date}} | Costo real {{amount}}",
costsLockedPendingVerification: "Los costos están bloqueados mientras la finalización está pendiente de verificación.",
quickFinishHint: "Finalización rápida: agregue los detalles de finalización y el costo real, luego envíe.",
costSummary: "Resumen de costos",
estimateLine: "Estimación: {{value}}",
actualTotalLine: "Total real: {{value}}",
vsEstimateLine: "frente a estimación: {{value}}",
actualCostHint: "El costo real debe incluir todos los cargos de esta orden de trabajo.",
optionalBreakdownHint: "Opcional: agregue un desglose detallado solo si es necesario.",
detailedCostBreakdown: "Desglose detallado de costos",
detailedCostBreakdownSummary: "Los materiales, la mano de obra, los impuestos y otros cargos son opcionales a menos que esta orden de trabajo necesite costos detallados.",
optionalDetailedCostBreakdown: "Desglose de costos detallado opcional",
materialsBreakdownOptional: "Desglose de materiales (opcional)",
lineItemsOptional: "Partidas (opcional)",
failedToAddLineItem: "El artículo no se añadió. Comprueba tu conexión e inténtalo de nuevo.",
add: "Agregar",
itemName: "Nombre del artículo",
removeItemTitle: "Quitar elemento",
removeItemBody: "¿Eliminar esta línea de pedido?",
cancel: "Cancelar",
remove: "Quitar",
error: "Algo salió mal",
failedToUpdateLineItem: "El artículo no se guardó. Comprueba tu conexión e inténtalo de nuevo.",
failedToRemoveLineItem: "El artículo no se quitó. Comprueba tu conexión e inténtalo de nuevo.",
failedToUpdateQty: "La cantidad no se guardó. Comprueba tu conexión e inténtalo de nuevo.",
failedToUpdateUnitCost: "El precio unitario no se guardó. Comprueba tu conexión e inténtalo de nuevo.",
failedToUpdateTotalCost: "El total no se guardó. Comprueba tu conexión e inténtalo de nuevo.",
quantityForItem: "Cantidad para {{name}}",
itemFallback: "artículo",
qty: "Cantidad",
unitCostForItem: "Costo unitario para {{name}}",
unit: "Unidad",
totalForItem: "Total para {{name}}",
total: "Total",
fromQtyTimesUnit: "De cantidad × unidad: {{amount}}",
manualTotalOverrideSuffix: " (cambiaste el total)",
useCalculatedTotal: "Usar total calculado",
materialsSubtotal: "Subtotal de materiales: {{amount}}",
labourTaxOtherOptional: "Cargos laborales, fiscales y otros (opcional)",
costBreakdownOptional: "Desglose de costos (opcional)",
failedToRemoveBreakdown: "El desglose no se quitó. Comprueba tu conexión e inténtalo de nuevo.",
failedToAddCostBreakdown: "El desglose no se añadió. Comprueba tu conexión e inténtalo de nuevo.",
removeBreakdown: "Quitar desglose",
addBreakdown: "Agregar desglose",
labourExTax: "Mano de obra (sin impuestos)",
taxEntry: "Entrada de impuestos",
amount: "Importe",
percentOfLabour: "% de mano de obra",
taxAmount: "Monto del impuesto",
taxRatePercentOfLabour: "Tasa impositiva (% de la mano de obra)",
taxRateLine: "Tasa impositiva: {{pct}}%",
otherCharges: "Otros cargos",
otherChargeLabel: "Etiqueta del otro cargo {{n}}",
label: "Etiqueta",
otherChargeAmount: "Importe del otro cargo {{n}}",
totalBreakdownLine: "Total = Materiales {{materials}} + Mano de obra {{labour}} + Impuestos {{tax}} + Otros {{other}}",
totalLine: "Total: {{amount}}",
invoicesAndCloseoutEmail: "Facturas y correo del informe",
invoicesAndCloseoutEmailSummary: "Adjunta facturas o envía el informe cuando la nota final esté lista.",
invoiceLabel: "Factura (PDF, imagen o Word)",
generateInvoiceWithAi: "Generar factura con IA",
reviewInvoiceDraft: "Revisar borrador de factura",
signInRequired: "Inicio de sesión necesario",
emailCloseoutRecipients: "Enviar el informe al solicitante",
emailAlwaysIncludesSummary: "El correo incluye un resumen del trabajo. Se adjuntan facturas, recibos y fotos si los hay.",
},
assetContextSection: {
asset: "Activo",
viewAssetKnowledgeBase: "Ver base de conocimientos de activos",
viewAssetKnowledge: "Ver conocimiento de activos",
noAssetLinked: "Ningún activo vinculado a esta orden de trabajo.",
overview: "Resumen",
location: "Ubicación",
fromLinkedAsset: "Del activo vinculado",
aboutThisJob: "Sobre esta orden de trabajo",
approverLine: "Aprobador: {{name}}",
approverFallback: "-",
sectionOfInterest: "Sección de interés",
viewSourceInspection: "Ver la inspección de origen",
fromInspection: "Desde la inspección",
video: "Vídeo",
photos: "Fotos",
linkedRecords: "Registros vinculados",
fromRequestLine: "Desde petición: {{id}}",
followsFromLine: "Deriva de: {{title}}",
parentJobFallback: "Orden de trabajo principal",
followOnLine: "Seguimiento: {{title}}",
sourceLine: "Fuente: {{label}}",
groupedScheduleLine_one: "{{count}} otra orden de trabajo activa en este activo se puede programar a la vez.",
groupedScheduleLine_other: "{{count}} otras órdenes de trabajo activas en este activo se pueden programar a la vez.",
groupedScheduleLine_many: "{{count}} otras órdenes de trabajo activas en este activo se pueden programar a la vez.",
},
scheduleSection: {
rescheduleTo: "Reprogramar para",
scheduleFor: "Programar para",
today: "Hoy",
tomorrow: "Mañana",
nextWeek: "Semana siguiente",
custom: "Personalizado",
selectDate: "Seleccionar fecha",
time: "Hora",
selectTime: "Seleccionar hora",
duration: "Duración",
plannedLine: "Planificado: {{value}}",
reasonOptional: "Motivo (opcional)",
reasonForReschedulePlaceholder: "Motivo de la reprogramación",
scheduleTogetherOptional: "Programar juntos (opcional)",
groupSameAssetHint: "Agrupa el trabajo del mismo activo para reducir las visitas repetidas.",
unscheduledSuffix: " | Sin programar",
cancel: "Cancelar",
reschedule: "Reprogramar",
schedule: "Programar",
},
deliveryModeSheet: {
cancel: "Cancelar",
saving: "Guardando...",
save: "Guardar",
},
mediaViewer: {
couldNotLoadImage: "No se pudo cargar la imagen",
imageUnavailable: "Es posible que la imagen se haya movido o no esté disponible.",
},
handoffRecommendationPanel: {
  evidence: {
    beforeAfter: "Al terminar: fotos de antes y después y una nota breve.",
    replacementPhotos: "Al terminar: fotos de antes y después y qué se instaló.",
    checklistPhotos: "Al terminar: la lista completada y fotos de lo que falló.",
  },
  reason: {
    originKept: {
      finding: "Sigue vinculado al hallazgo de la inspección.",
      inspection: "Sigue vinculado a la inspección.",
      request: "Sigue vinculado a la solicitud.",
      asset: "Sigue vinculado al activo.",
    },
    noOrigin: "Revisa los detalles de arriba antes de crearlo.",
    skillsUnconfirmed: "Aún no hay habilidades. Añádelas si hace falta un oficio concreto.",
    skillsCarried_many: "El trabajo ya tiene {{count}} habilidades.",
    skillsCarried_other: "El trabajo ya tiene {{count}} habilidades.",
    skillsCarried_one: "El trabajo ya tiene {{count}} habilidad.",
    dueByPriority_many: "Prioridad {{priority}}: intenta terminar en {{count}} días.",
    dueByPriority_other: "Prioridad {{priority}}: intenta terminar en {{count}} días.",
    dueByPriority_one: "Prioridad {{priority}}: intenta terminar en {{count}} día.",
    contractorNoInternal: "Nadie de tu equipo está libre: elige un contratista.",
    contractorFromSourceJob: "Vuelve al contratista que hizo el trabajo del que surgió.",
    contractorCritical: "Nadie de tu equipo está libre y es urgente: envíalo directamente a un contratista de confianza.",
    quotesHighValue: "Nadie de tu equipo está libre y es un trabajo costoso: compara antes varios presupuestos.",
    internalAvailableUnnamed: "Alguien de tu equipo puede hacerlo.",
    internalAvailable: "{{name}}, de tu equipo, puede hacerlo.",
  },
recommendedHandoff: "Sugerencia",
titleLine: "{{mode}} · vence en {{days}} {{dayWord}}",
dayWord_one: "día",
dayWord_other: "días",
applied: "Aplicado",
apply: "Usar esta sugerencia",
whyRecommendedTitle: "¿Por qué?",
priorityOverrideLine: "Prioridad: {{priority}}. Cámbiala en Añadir contexto si no es correcta.",
planningRangeLine: "Rango de planificación {{min}}–{{max}}; confírmalo antes de encargar el trabajo.",
dayWord_many: "días",
},
statusInsight: {
theReviewer: "El revisor",
reworkRequested: "Devuelto",
workPath: "Quién lo hace",
updating: "Actualizando...",
internal: "Interno",
recipientView: "Vista de destinatarios",
recipientViewBody: "Puedes revisar esta orden de trabajo. La edición está limitada a lo que permite tu rol.",
execution: "Ejecución del trabajo",
executionBody: "Cuando acabes, toca Completar para añadir tu nota, fotos y costes.",
nextStep: "Siguiente paso",
nextLine: "Siguiente: {{actor}}",
followOnApproval: "Aprobación del seguimiento",
followOnApprovalBody: "Aprueba este trabajo de seguimiento para poder asignarlo y fecharlo.",
awaitingFollowOnApproval: "Pendiente de aprobación",
waitingForApproverBody: "Este trabajo de seguimiento espera aprobación. No se puede asignar ni fechar hasta entonces.",
waitingForParentApproverBody: "Esta orden de trabajo no se puede asignar ni programar hasta que decida quien aprueba la orden de trabajo principal.",
overdue: "Vencido",
unscheduled: "Sin programar",
},
activitySection: {
  assistantChange: "Cambiado a través del asistente",
  assistantUndone: "Cambio del asistente deshecho",
  playVideo: "Reproducir vídeo",
  openPhoto: "Abrir foto",
statusNone: "Ninguno",
systemActor: "Sistema",
userFallback: "Alguien del equipo",
taskTimeline: "Cronograma de tareas",
purposeHint: "Estado, mensajes, evidencia y acciones en un espacio de trabajo cronológico.",
noStatusEvents: "Aún no hay eventos de estado.",
recentEvidence: "Evidencia reciente",
noMessagesOrEvidence: "Aún no hay mensajes ni pruebas.",
openFullTimeline: "Abrir línea de tiempo completa >",
},
assignmentSection: {
contacts: "Contactos",
noContactsLinked: "No hay contactos vinculados.",
contactFallback: "Contacto",
couldNotUnlinkTitle: "No se pudo desvincular el contacto",
tryAgain: "Inténtelo de nuevo.",
linkContact: "Vincular contacto",
assignmentAndSchedule: "Asignación y horario",
declinedSuffix: "{{name}} (rechazado)",
awaitingAssignee: "Pendiente de responsable",
requesterLine: "Solicitante: {{name}}",
requesterEmailSuffix: " ({{email}})",
notLinkedYet: "Aún no vinculado",
scheduledLine: "Programado: {{value}}",
notScheduledYet: "Aún sin programar",
closeoutRecipientsFallback: "Cuando se asigne a alguien, verás quién recibe el informe final.",
completionEmailLine: "Correo electrónico de finalización: {{value}}",
rejected: "Rechazada",
changeAssignee: "Cambiar responsable",
change: "Cambiar",
reassign: "Reasignar",
contractorType: "Contratista",
internalTeamType: "Equipo interno",
reason: "Motivo",
invitedAcceptedDeclinedLine: "Invitado: {{total}} | Aceptado: {{accepted}} | Rechazado: {{declined}}",
pendingSuffix: " | Pendientes: {{pending}}",
quoteRequestLine: "Solicitud de presupuesto: {{status}}",
quoteInvitedSubmittedDeclinedLine: "Invitados: {{invited}} | Enviados: {{submitted}} | Rechazados: {{declined}}",
quoteCountLine_one: "{{count}} presupuesto: {{open}} abierto | {{accepted}} aceptado | {{rejected}} rechazado",
quoteCountLine_many: "{{count}} presupuestos: {{open}} abiertos | {{accepted}} aceptados | {{rejected}} rechazados",
quoteCountLine_other: "{{count}} presupuestos: {{open}} abiertos | {{accepted}} aceptados | {{rejected}} rechazados",
awardedToLine: "Otorgado a: {{name}}",
execution: "El trabajo",
started: "Iniciada",
completed: "Completado",
actualDuration: "Duración real",
elapsed: "Transcurrido",
confirmed: "Confirmado",
confirmedBySuffix: " · {{name}}",
verified: "Verificada",
continueJob: "Continuar la orden de trabajo",
continueJobHint: "Agregue los detalles de finalización y el costo real antes de enviar.",
completion: "Finalización",
},
statusGuidance: {
title: "Estado y orientación",
},
invoicePreview: {
title: "Revisar borrador de factura de IA",
hint: "Confirme los detalles y luego adjunte el PDF generado a esta orden de trabajo.",
titleAndNumber: "{{title}} - {{number}}",
issueDate: "Fecha de emisión: {{date}}",
dueDateSuffix: " | Vencimiento: {{date}}",
from: "De",
billTo: "Facturar a",
lineItems: "Partidas",
lineItemLine: "{{description}} x{{quantity}} - {{amount}}",
total: "Total: {{amount}}",
noDraftFound: "No se encontró ningún borrador. Primero genere un borrador de factura.",
back: "Atrás",
attaching: "Adjuntando…",
attachPdf: "Adjuntar PDF",
},
followOnModals: {
proposeTitle: "Proponer un trabajo de seguimiento",
proposeHint: "Espera aprobación. Una vez aprobado, se puede asignar y fechar.",
titleLabel: "Título",
descriptionLabel: "Descripción",
dictate: "Dictar",
improving: "Mejorando…",
improveWithAi: "Mejora con IA",
followOnTitleAria: "Título del trabajo de seguimiento",
titlePlaceholder: "Título",
followOnDescriptionAria: "Descripción del trabajo de seguimiento",
descriptionPlaceholder: "¿Qué trabajo extra se necesita?",
insertingDictatedText: "Insertando texto dictado...",
finishingDictation: "Finalizando el dictado...",
heardTranscript: "Escuchado: {{transcript}}",
listening: "Escuchando...",
photosAndVideos: "Fotos y vídeos",
requiredSkills: "Habilidades requeridas",
cancel: "Cancelar",
submitting: "Enviando…",
submitForApproval: "Enviar para aprobación",
rejectTitle: "Rechazar el trabajo de seguimiento",
rejectHint: "El trabajo de seguimiento se cancela. Añade un motivo breve para el equipo.",
rejectionReasonAria: "Motivo del rechazo",
reasonPlaceholder: "Motivo",
rejectFollowOn: "Rechazar",
},
dockBar: {
  waitingForRequester: "Esperando al solicitante",
approve: "Aprobar",
reject: "Rechazar",
accept: "Aceptar",
acceptAndStart: "Aceptar y empezar",
acceptAndSchedule: "Aceptar y programar",
cantDoThis: "Rechazar",
reassign: "Reasignar",
rework: "Devolver",
requestEvidence: "Pedir fotos",
verify: "Dar conformidad",
resubmit: "Volver a enviar",
getQuotes: "Pedir presupuestos",
inviteMore: "Invitar más",
compare: "Comparar",
sendQuotes: "Enviar presupuestos",
assign: "Asignar",
startNow: "Iniciar ahora",
schedule: "Programar",
start: "Iniciar",
reschedule: "Reprogramar",
complete: "Completar",
pause: "Pausar",
resume: "Reanudar",
report: "Informe",
},
certificateSuggestion: {
needsConnection: "Las sugerencias de certificados necesitan una conexión.",
evidenceDoesNotSupport: "La evidencia de finalización aún no respalda claramente un certificado.",
createPendingTitle: "Crear certificado pendiente",
createPendingBody: "¿Crear un certificado a partir de esta orden de trabajo? Quedará pendiente de validación hasta que se revise.",
cancel: "Cancelar",
continue: "Continuar",
jobFallback: "Trabajo",
certificateSuffix: "Certificado de {{title}}",
titleLine: "Título: {{value}}",
typeLine: "Tipo: {{value}}",
expiryLine: "Caducidad: {{value}}",
cardTitle: "Sugerir certificado a partir de evidencia de finalización",
optionalAiHint: "Asistencia de IA opcional después de completar la orden de trabajo.",
reviewDraftLabel: "Revisar borrador de certificado",
suggestWithAi: "Sugerir certificado con IA",
addManually: "Agregar certificado manualmente",
},
verified: {
  submitCheckNote: "Al enviar, la IA compara las fotos de después con lo que pide el trabajo.",
  documentHintSheet: "Cierre esto y toque Adjuntar documento en el trabajo.",
  noteHintSheet: "Escríbala en la nota de cierre de esta pantalla.",
  noteHint: "Escríbala en la nota de cierre cuando toque Completar.",
  attachDocument: "Adjuntar documento",
  recordReading: "Registrar lectura",
  heading: "Qué necesita este trabajo",
  progress: "{{done}} de {{total}} hechos",
  takePhoto: "Hacer foto",
  stage: {
    pre: "Antes de empezar",
    post: "Al terminar",
    standalone: "Lista de comprobación",
  },
  beforePhoto: "Foto de antes",
  afterPhoto: "Foto de después",
  beforePhotos: "Fotos de antes",
  addBeforePhoto: "Añadir foto de antes",
  required: "Obligatorio",
  recommended: "Recomendado",
  rowState: {
    notSupplied: "No aportado",
    done: "Hecho",
    uploading: "Subiendo…",
    added: "Añadida",
    missing: "Falta",
    attention: "Necesita revisión",
    unchecked: "Sin comprobar",
  },
  status: {
    consistent: "Las fotos coinciden con el trabajo descrito",
    review_required: "Las fotos necesitan revisión",
    missing_evidence: "Faltan fotos",
    inconsistent: "Las fotos no coinciden con el trabajo descrito",
    unable_to_determine: "No se pudo determinar con las fotos",
  },
  checkNote: {
    meter_not_recorded: "Lectura del contador no registrada",
    document_not_attached: "Documento no adjuntado",
    check_not_completed: "Comprobación no completada",
    note_missing: "Falta la nota",
    not_visible: "No visible en las fotos",
    partly_visible: "Solo parcialmente visible",
    low_confidence: "No es lo bastante claro",
    contradicted: "Las fotos muestran lo contrario",
    cloud_unavailable: "Evaluación automática no disponible",
    not_visually_verifiable: "No se puede determinar a partir de fotos",
  },
  warning: {
    cloud_unavailable: "Evaluación automática no disponible. La persona revisora puede seguir examinando las pruebas.",
    subject_mismatch: "Las fotos de antes y después podrían no mostrar el mismo componente.",
    low_quality_after: "Las fotos de después están borrosas, oscuras u obstruidas. Se recomiendan fotos más claras.",
    new_defect_after: "En las fotos de después se ve un defecto que el trabajo no cubría.",
    detector_disagreement: "Las fotos apuntan en ambos sentidos. Decide una persona.",
    pending_uploads: "Algunas fotos aún se están subiendo y no se evaluaron.",
    reviewer_required: "Una persona revisora debe aprobar este trabajo.",
    post_inspection_required: "Inspección final pendiente.",
  },
  moreEvidenceRequested: "Se pidieron más fotos",
  stale: "Las pruebas cambiaron. Hay que actualizar la evaluación.",
  checkEvidence: "Comprobar fotos",
  checkAgain: "Comprobar de nuevo",
  checking: "Comprobando las pruebas de finalización…",
  checkEvidenceA11y: "Comprobar las pruebas de finalización",
  resubmit: "Volver a enviar",
  resubmitA11y: "Volver a enviar la finalización con las pruebas añadidas",
  resubmitted: "Reenviado para revisión. Se ha avisado al revisor.",
  requestEvidence: "Pedir fotos",
  requestEvidenceA11y: "Pedir más fotos",
  cloudUnavailable: "La comprobación automática de fotos no está disponible ahora. Mire las fotos y decida.",
  reportEyebrow: "Evaluación de pruebas (automática)",
  editRequirements: "Editar lo necesario",
  editSummary: "Listas, fotos y resultados de este trabajo",
  saved: "Requisitos guardados. Cualquier evaluación anterior debe actualizarse.",
  suggestFailed: "No llegaron sugerencias. Añade los resultados a mano.",
  kind: {
    visual: "Se ve en fotos",
    meter: "Lectura de contador",
    document: "Documento",
    check: "Lista de comprobación",
    note: "Nota",
  },
  remove: "Quitar",
  removeA11y: "Quitar «{{text}}»",
  addOutcomePlaceholder: "Añade un resultado esperado, p. ej. Protector de repuesto presente",
  addOutcome: "Añadir resultado",
  suggestWithAi: "Sugerir con IA",
  saveRequirements: "Guardar requisitos",
  reportPhotosAssessed: "Fotos evaluadas",
  reportRecordsOnly: "Solo registros",
},
closeoutPane: {
askForPhotos: "Pedir fotos",
viewCompletionReport: "Ver informe de finalización",
emailCloseoutRecipients: "Enviar el informe al solicitante",
sending: "Enviando…",
waitingOnRequester: "Esperando al solicitante",
verifyCompletedWork: "Dar conformidad al trabajo completado",
requesterGatePendingBody: "El solicitante revisa primero el trabajo. Cuando confirme que está conforme, toca Verificar para cerrar el trabajo. Aún puedes Devolver.",
requesterAcceptedBody: "El solicitante confirmó que está conforme. Toca Dar conformidad para cerrar el trabajo.",
reviewAndApproveBody: "Revisa la nota, las fotos y los costes y toca Dar conformidad para cerrar el trabajo, o Devolver si hay que arreglar algo.",
requestRework: "Devolver",
rework: "Devolver",
verify: "Dar conformidad",
certificateRenewalTitle: "Renovación del certificado",
certificateRenewalBody: "Cree el certificado de reemplazo a partir de esta orden de trabajo completada y vincúlelo al certificado anterior.",
createCertificateFromJob: "Crear certificado a partir de orden de trabajo",
createCertificate: "Crear certificado",
},
assignSheet: {
  chooseContractorsToQuote: "Elegir contratistas para presupuestar",
  chooseContractor: "Elegir un contratista",
  assignToContractor: "Asignar a un contratista",
  inviteTeammate: "Invitar a un compañero",
close: "Cerrar",
youSuffix: "{{name}} (Tú)",
searchTeamMembersPlaceholder: "Buscar miembros del equipo…",
noTeamMemberMatch: "Ningún miembro del equipo coincide.",
createTeamHint: "Añade a un compañero para asignarle trabajo, o asígnatelo a ti.",
teammate: "Asignar a un compañero",
assignToMyself: "Asignarme a mí mismo",
},
},
create: {
  skillsTryAgain: "Reintentar",
  skillsEmpty: "No hay habilidades para elegir ahora. Toca Reintentar o sigue sin ninguna.",
  createAndAssignJob: "Crear y asignar el trabajo",
  fromRequestPageTitle: "Confirmar trabajo desde la solicitud",
  checkAttachFailedTitle: "Trabajo creado, falta la lista",
  assetLoadFailed: "No se pudo cargar el activo vinculado. Comprueba tu conexión y vuelve a intentarlo.",
  assetUnavailable: "Este activo no está disponible o ya no tienes acceso.",
  assetStatus: {
    retired: "Retirado definitivamente",
    archived: "Archivado",
    active: "Activo",
  },
  visibilityHint: "Privado: solo tú y las personas de este trabajo. Equipo: todo tu equipo.",
  priorityOption: {
    critical: "Crítica",
    high: "Alta",
    medium: "Media",
    low: "Baja",
  },
  categoryOption: {
    other: "Otra",
    replacement: "Sustitución",
    inspection: "Inspección",
    maintenance: "Mantenimiento",
    repair: "Reparación",
  },
unsavedGuard: {
message: "Esta orden de trabajo aún no se ha creado. ¿Salir y perderla?",
discard: "Salir",
keep: "Sigue editando",
},
assetRetiredTitle: "Activo retirado definitivamente",
assetArchivedTitle: "Activo archivado",
assetRetiredBody: "Este activo se ha retirado definitivamente (fuera de servicio). Su historial se puede seguir consultando, pero no admite nuevas órdenes de trabajo.",
assetArchivedBody: "Este activo está archivado. Aún puede ver/editar el activo, pero no puede crear nuevas órdenes de trabajo para él.",
linkFollowUpFallback: "La solicitud no se actualizó.",
checkAttachFailed: "El trabajo se creó, pero no se añadió la lista «{{name}}». Abre el trabajo y toca Añadir revisión.",
createFailed: "El trabajo no se creó. Tus datos se conservan. Comprueba tu conexión e inténtalo de nuevo.",
error: "Algo salió mal",
followUpLinked: "Seguimiento vinculado a orden de trabajo",
calendarInviteTitle: "Orden de trabajo: {{name}}",
genericAssetFallback: "Activo",
recovery: {
followUpTitle: "Trabajo creado, solicitud sin actualizar",
followUpBody: "{{message}} El trabajo se creó. Toca Reintentar vínculo para que aparezca en la solicitud.",
retryLink: "Reintentar vínculo",
openJob: "Abrir orden de trabajo",
assetErrorTitle: "No se pudo cargar el activo vinculado",
assetLoadingTitle: "Cargando el activo vinculado...",
assetErrorBody: "{{error}} Se conserva el resumen de trabajo ingresado.",
retryAsset: "Reintentar activo",
requestErrorTitle: "No se pudo cargar la solicitud",
requestErrorBody: "Esta orden de trabajo debe completarse previamente a partir de la solicitud. Vuelva a intentar cargar sus detalles: todo lo que ya haya ingresado se conserva.",
retry: "Reintentar",
},
createdFromRequest: "Creado a partir de solicitud",
createdFromAsset: "Creado a partir de activo",
notSet: "Sin definir",
noPriority: "Sin prioridad",
openAsset: "Abrir activo",
followOnDetailsTitle: "Detalles del trabajo de seguimiento",
workBriefTitle: "Resumen del trabajo",
followOnHint: "Vinculado al trabajo original{{parent}}. Usa el mismo activo y la misma forma de hacerlo. Asígnalo y elige fecha cuando se apruebe.",
workPathTitle: "¿Quién lo hace?",
linkAssetLabel: "Vincular a un activo (opcional)",
selectAssetPlaceholder: "Seleccione un activo",
titleLabel: "Título",
titlePlaceholder: "por ej. Reparar grifo que gotea",
titleError: "Ingrese el título de una orden de trabajo para continuar.",
descriptionLabel: "Describe el problema (opcional)",
descriptionPlaceholder: "¿Qué hay que hacer? Añade detalles para que el responsable tenga contexto.",
dictateStop: "Detener",
dictateStart: "Dictar",
cleaningUp: "Mejorando…",
aiCleanUp: "Mejorar con IA",
photosLabel: "Fotos (opcional, máximo 3)",
completionEvidence: {
  title: "Pruebas de finalización",
  summary: "Qué pruebas del trabajo terminado necesita este trabajo",
  beforePhoto: "Foto de antes",
  afterPhoto: "Foto de después",
  level: {
    none: "No necesaria",
    recommended: "Recomendada",
    required: "Obligatoria",
  },
  reviewerRequired: "Debe aprobarlo una persona revisora",
  postInspection: "Inspección posterior",
  requiredHint: "Las pruebas obligatorias bloquean la finalización hasta que se añaden.",
  recommendedHint: "Las pruebas recomendadas avisan pero nunca bloquean.",
},
categoryLabel: "Categoría *",
categoryError: "Elija una categoría para continuar.",
skillsOptionalLabel: "Habilidades (opcional)",
requiredSkillsLabel: "Habilidades requeridas",
requiredSkillsError: "Elige al menos una habilidad para el trabajo de seguimiento. Se rellenan las del trabajo original si las tiene.",
requiredSkillsHint: "Elige al menos una habilidad. Se rellenan las del trabajo original si las tiene.",
addContext: "Añadir contexto (opcional)",
priorityLabel: "Prioridad",
locationLabel: "Ubicación (opcional)",
locationPlaceholder: "Buscar dirección…",
assignScheduleTitle: "Asignar y programar",
assignScheduleSummary: "Fecha de vencimiento, programación y responsable",
dueDateLabel: "Fecha de vencimiento (opcional)",
selectDatePlaceholder: "Seleccionar fecha",
dueDateHint: "Fecha de finalización prevista. Deje la programación en blanco si este trabajo aún no necesita un espacio específico.",
scheduledDateLabel: "Fecha programada (opcional)",
planDatePlaceholder: "Fecha del plan",
startTimeLabel: "Hora de inicio",
selectTimePlaceholder: "Seleccionar hora",
estimatedDurationLabel: "Duración estimada",
suggestedDuration: "Sugerido: {{duration}} ({{reason}})",
useSuggestedDuration: "Utilice la duración sugerida",
applied: "Aplicado",
useSuggestion: "Usar sugerencia",
plannedPreview: "Planificado: {{preview}}",
clearSchedule: "Borrar programación",
inviteLabel: "Invitar (opcional)",
setDateHint: "Establezca una fecha para planificar cuándo debe comenzar el trabajo.",
quotesContractorHint: "Usted elige qué contratistas invitar a presentar presupuesto después de crear la orden de trabajo.",
directContractorHint: "Usted elige el contratista después de crear la orden de trabajo.",
assignTeamMemberLabel: "Asignar a miembro del equipo (opcional)",
searchTeamMembersPlaceholder: "Buscar miembros del equipo…",
noTeamMemberMatch: "Ningún miembro del equipo coincide.",
assignSuggestedMember: "Asignar al miembro sugerido, {{name}}",
suggestedAssignee: "Sugerido: {{name}}",
assignAnytimeHint: "Asigne ahora o asigne después de crear la orden de trabajo.",
advancedSettingsTitle: "Más detalles",
advancedSettingsSummary: "Categoría, duración, comprobaciones, invitación de calendario, coste y visibilidad",
estimatedCostLabel: "Costo estimado (opcional)",
estimatedCostAmount: "Monto del costo estimado",
visibilityLabel: "Visibilidad",
submitting: "Enviando…",
submitForApproval: "Enviar para aprobación",
creating: "Creando…",
createJob: "Crear orden de trabajo",
followOnPageTitle: "Proponer un trabajo de seguimiento",
createPageTitle: "Crear orden de trabajo",
followOnSubtitle: "Espera aprobación antes de poder asignarse.",
requestSubtitle: "Revisa los detalles, elige quién lo hace y para cuándo, y toca Crear y asignar el trabajo.",
manualSubtitle: "Describe el trabajo y elige una categoría. Puedes asignarlo y programarlo a continuación.",
linkAssetSheetTitle: "Vincular a un activo",
noneOption: "Ninguno",
openLinkedAsset: "Abrir activo vinculado",
cleanedDescriptionTitle: "Descripción depurada",
cleaningUpDescription: "Mejorando la descripción",
reviewSuggestedWording: "Revise la redacción sugerida antes de aplicarla.",
unableToCleanUpTitle: "No se puede limpiar la descripción",
tryAgain: "Inténtelo de nuevo.",
},
recurring: {
  addStepNote: "Este plan será el paso {{n}} de {{name}}.",
  saved: {
    dateInspection: "Plan guardado. La primera inspección aparecerá en Trabajo el {{when}}.",
    dateJob: "Plan guardado. La primera orden de trabajo aparecerá en Trabajo el {{when}}.",
    meterInspection: "Plan guardado. La primera inspección aparecerá en Trabajo cuando el contador llegue a {{amount}}.",
    meterJob: "Plan guardado. La primera orden de trabajo aparecerá en Trabajo cuando el contador llegue a {{amount}}.",
    eitherInspection: "Plan guardado. La primera inspección aparecerá en Trabajo a los {{amount}} o el {{when}}, lo que llegue antes.",
    eitherJob: "Plan guardado. La primera orden de trabajo aparecerá en Trabajo a los {{amount}} o el {{when}}, lo que llegue antes.",
    conditionInspection: "Plan guardado. Aparecerá una inspección en Trabajo cuando la puntuación de estado baje a {{score}} o menos.",
    conditionJob: "Plan guardado. Aparecerá una orden de trabajo en Trabajo cuando la puntuación de estado baje a {{score}} o menos.",
    manual: "Plan guardado. No aparecerá nada en Trabajo hasta que alguien pulse Iniciar ahora en la pestaña Mantenimiento del activo.",
    needsReading: "Plan guardado. Registre una lectura del contador en el activo para que empiece a contar.",
    nowInspection: "Plan guardado. La primera inspección ya está en Trabajo.",
    nowJob: "Plan guardado. La primera orden de trabajo ya está en Trabajo.",
    generic: "Plan guardado. Lo encontrará en la pestaña Mantenimiento del activo.",
  },
  skipPolicy: {
    hint: {
      not_allowed: "Una visita se puede mover o pasar a otra persona, pero nunca omitir.",
      no_approval: "Quien hace el trabajo puede omitir una visita al momento. Se avisa a los aprobadores del activo.",
      team_admin: "Solo el propietario o un administrador del equipo puede aceptar omitir una visita.",
      requires_approval: "Cualquiera puede pedir omitir o mover una visita; decide uno de los aprobadores del activo.",
      default: "Sin elegir: decide un encargado; un administrador del equipo si el activo tiene una obligación de cumplimiento.",
    },
    not_allowed: "No omitir nunca",
    no_approval: "Omitir sin preguntar",
    team_admin: "Decide un administrador del equipo",
    requires_approval: "Decide un encargado",
    label: "Si una visita no se puede hacer",
  },
  meterNowHint: "Se guarda como primera lectura para que el plan sepa desde dónde contar.",
  meterNow: "Lectura actual del contador",
  createTemplate: "Crear una lista de control",
  noTemplates: "Aún no hay listas de control. Cree una y se elegirá aquí automáticamente.",
  addDocument: "Añadir un documento",
  pickAssetFirst: "Elija primero el activo y después uno de sus documentos.",
  cannotManage: "No puede añadir planes a {{asset}}. Pídaselo a su propietario o a un administrador del equipo.",
  assetPickerSubtitle: "Un plan pertenece a un solo activo. Su trabajo aparece en Trabajo para ese activo.",
maintenanceSave: "Crear plan",
maintenanceSuccessTitle: "Plan creado",
maintenanceSuccessBody: "El trabajo se genera cuando el plan vence. Gestiónalo desde la pestaña Mantenimiento del activo.",
maintenanceHeading: "Plan de mantenimiento",
maintenanceSub: "Trabajo que se repite: un servicio, una prueba o una inspección. Elija el activo, indique qué se hace y cuándo toca. La orden de trabajo aparece en Trabajo cada vez que vence.",
modeWhenDue: "Cuando corresponda",
repeatEvery: "Repetir por fecha",
everyCount: "Cada",
unit: {
hours: "horas",
days: "días",
weeks: "semanas",
months: "meses",
years: "años",
},
edit: {
  loadFailed: "No se pudo abrir este plan. Compruebe la conexión e inténtelo de nuevo.",
heading: "Editar plan",
sub: "Los cambios se aplican a partir de la próxima vez que se active el plan. El trabajo ya generado no cambia.",
save: "Guardar cambios",
savedTitle: "Plan actualizado",
savedBody: "El cambio se aplica a partir de la próxima vez que se active el plan. El trabajo ya generado no cambia.",
notFound: "No se ha encontrado este plan. Puede que se haya finalizado.",
conflict: "Otra persona guardó este plan después de que lo abrieras. Tus cambios no se aplicaron: vuelve, ábrelo de nuevo y repítelos.",
},
meterEvery: "Repetir por contador",
meterInterval: "Cada",
meterKind: {
mileage: "Kilometraje",
operating_hours: "Horas",
cycles: "Ciclos",
},
meterCurrent: "El contador marca {{amount}} ahora.",
meterNoReading: "Todavía no hay ninguna lectura — registra una en el activo para que el plan tenga algo desde donde contar.",
whicheverFirst: "Lo que ocurra primero",
lastDone: "Última vez realizado (opcional)",
lastDoneDate: "Fecha",
lastDoneTime: "Hora",
lastDoneMeter: "Contador en el último servicio",
lastDoneHint: "Déjalo en blanco para contar desde hoy y la lectura actual.",
moreOptions: "Más opciones",
meterAlso: "Repetir también por lectura del contador",
meterRemove: "Quitar la repetición por contador",
unitPickerTitle: "Repetir cada",
lastDoneHintNow: "Déjalo en blanco si nunca se ha hecho.",
whoDoesIt: "Quién lo hace (opcional)",
nobodyYet: "Decidir cada vez",
whoDoesItHint: "Cada visita se asigna a {{name}}, que recibe un aviso cuando llega.",
nobodyYetHint: "Cada visita llega hasta dos semanas antes de su vencimiento y se te pide que la asignes, con un recordatorio 3 días antes.",
assetPlaceholder: "Elegir un activo",
firstRunDatePlaceholder: "Fecha",
firstRunTimePlaceholder: "Hora",
ok: "Entendido",
unsavedGuard: {
editMessage: "Sus cambios en este plan no se han guardado. ¿Salir y perderlos?",
createMessage: "Este plan aún no se ha guardado. ¿Salir y perderlo?",
discard: "Salir",
keep: "Sigue editando",
},
doItAs: "Hacerlo como",
asJob: "Orden de trabajo",
asInspection: "Inspección",
pickTemplate: "Elija una lista de control",
serviceReading: "Lectura del contador en el servicio",
useReading: "Usar {{amount}} como lectura de servicio",
heading: "Plan de mantenimiento",
sub: "Crea el siguiente trabajo por ti según un calendario: al terminar el anterior o en la fecha prevista.",
asset: "Activo",
title: "Qué se hace",
titlePh: "p. ej. Revisión anual",
description: "Detalles (opcional)",
descriptionPh: "Qué hacer cada vez",
category: "Categoría",
firstRun: "Primera ejecución (fecha y hora)",
recurrence: "Repetición",
advanceMode: "¿Cómo debe crearse el siguiente trabajo?",
modeCompletion: "Tras finalizar el trabajo anterior",
modeCalendar: "En la fecha de vencimiento del calendario",
modeHint: {
when_due: "El siguiente trabajo aparece cuando lo indica la fecha o el contador, lo que ocurra primero. No se crea nada hasta entonces.",
on_completion: "El siguiente trabajo aparece después de que completes o canceles el actual de esta serie.",
on_calendar: "Se crea un trabajo nuevo cuando llega cada fecha de vencimiento, aunque el trabajo anterior siga abierto (a menos que actives la opción de omitir abajo).",
},
skipIfPriorOpen: "Omitir el siguiente si el anterior sigue abierto",
seriesLimits: "Dejar de repetir (opcional)",
seriesLimitsHint: "Deje ambos en blanco para que siga repitiéndose.",
endDate: "Finalizar en la fecha",
endTime: "Hora de fin",
checksHint: "Se añade a cada trabajo que crea este plan.",
maxJobs: "Parar tras este número de trabajos",
maxPh: "Sin límite",
save: "Crear serie",
saving: "Creando…",
successTitle: "Serie creada",
successBody: "La primera orden de trabajo ya está en Trabajo; las siguientes seguirán tu calendario.",
errorTitle: "Plan no guardado",
footer: "Activo: {{asset}}",
errors: {
  meterNowFailed: "No se pudo guardar esa lectura. Compruebe el número e inténtelo de nuevo.",
  meterNow: "Introduzca la lectura actual del contador.",
every: "Introduce la frecuencia como un número entero.",
meter: "Introduce la frecuencia en {{unit}}.",
noLeg: "Añade una repetición por fecha, por contador, o ambas.",
template: "Elija una lista de control para la inspección.",
lastDone: "Elige una fecha de última vez válida, o déjala en blanco.",
lastDoneMeter: "Introduce la lectura del último servicio, o déjala en blanco.",
readingLower: "La lectura de servicio es menor que la actual {{amount}}.",
asset: "Elija el activo de este plan.",
title: "Indique qué se hace.",
datetime: "Elige una fecha y hora de primera ejecución válidas.",
endInvalid: "Elija una fecha de fin válida.",
endBeforeStart: "La fecha de fin debe ser igual o posterior a la primera.",
max: "Indique cuántos trabajos o déjelo en blanco.",
generic: "Su plan no se ha guardado. Compruebe la conexión e inténtelo de nuevo.",
},
serviceReadingHint: "El próximo mantenimiento se cuenta a partir de esta lectura.",
dueBy: "¿Cuándo toca?",
trigger: {
  schedule: "Cada…",
  fixed_date: "En fechas fijas",
  document_renewal: "Cuando vence un documento",
  condition: "Cuando baja el estado",
  manual: "Sin programación, lo inicio yo",
},
triggerHint: {
  fixed_date: "Se genera trabajo en cada fecha.",
  document_renewal: "Se genera trabajo cuando vence el documento. Al registrar su renovación, el plan pasa a la nueva fecha de vencimiento.",
  condition: "Se genera trabajo cuando la puntuación de estado del activo baja a este valor o menos.",
  manual: "No se genera nada por sí solo. Inícialo desde la pestaña Mantenimiento del activo cuando haga falta.",
},
dates: "Fechas",
addDate: "Añadir una fecha",
removeDate: "Quitar esta fecha",
pickDocument: "Elige un documento",
documentExpires: "{{title}} · vence el {{when}}",
noDocuments: "Este activo aún no tiene ningún documento con fecha de vencimiento. Añada uno y vuelva para elegirlo.",
conditionScore: "Puntuación de estado (0–100)",
errorDates: "Añade al menos una fecha.",
errorDocument: "Elige el documento cuyo vencimiento hace vencer el plan.",
errorCondition: "Introduce una puntuación de estado de 0 a 100.",
},
handoff: {
  couldNotLoadTeam: "No se pudo cargar el equipo. Comprueba tu conexión y toca Reintentar.",
  assignToMyself: "Asignármelo",
  inviteTeammate: "Invitar a un compañero",
  createdSubtitleAssigned: "Ya está en Trabajo y asignado a {{name}}. Elige una fecha cuando lo acepte.",
  createdSubtitle: "Ya está en Trabajo. Elige quién lo hace y cuándo. Se le avisará cuando se lo asignes.",
  createdTitle: "Trabajo creado",
  assignTitle_many: "Asignar los trabajos",
  assignTitle_other: "Asignar los trabajos",
  assignTitle_one: "Asignar el trabajo",
pageTitle: "Asignar el trabajo",
releaseFollowUpTitle: "Aprobar el trabajo de seguimiento",
releaseSubtitle: "Apruébalo, elige quién lo hace y fija una fecha.",
batchSubtitle: "Elige quién hace cada trabajo y cuándo. Se les avisará cuando se los asignes.",
emptyTitle: "No hay trabajos que asignar",
emptyBody: "Aquí no hay trabajos que asignar. Vuelve a Trabajo para buscar otros.",
backToWork: "Volver a Trabajo",
releaseHandoffTitle: "Aprobar y asignar",
smoothHandoffTitle: "Asigna cada trabajo",
releaseIntroText: "Cada tarjeta muestra quién pidió el trabajo, quién lo hace, cuándo y quién recibe el informe final. Al aprobarlo se puede asignar y fechar.",
batchIntroText: "Cada tarjeta muestra quién pidió el trabajo, quién lo hace, cuándo y quién recibe el informe final. Al asignar uno, aparece el siguiente.",
applyToAllJobs: "Aplicar a las {{count}} órdenes de trabajo",
scheduleAllJobsTogether: "Programe todas las órdenes de trabajo juntas",
scheduleTogether: "Agendar juntos",
setWorkPathToAllJobs: "Para todos los trabajos: {{mode}}",
allInternal: "Todo a nuestro equipo",
allToContractor: "Todo a un contratista",
allToQuotes: "Presupuestos para todos",
pendingRelease: "Pendiente de aprobación",
requester: "Solicitante",
noRequesterLinked: "Aún no hay solicitante vinculado",
requesterNoneLinked: "No hay solicitante vinculado: solo tu equipo recibe el informe.",
assigneeLine: "Responsable: {{name}}",
setOnRelease: "Se elige al aprobar",
verbAssignToTeam: "asignar al equipo",
verbAssignToContractor: "asignar al contratista",
verbRequestQuotes: "solicitar presupuestos",
approveAndVerb: "Aprobar y {{verb}}",
changeAssignee: "Cambiar responsable",
workPathLabel: "¿Quién lo hace?",
assigneeLabel: "Responsable",
plannedDateLabel: "Fecha prevista",
completionRecipientsLabel: "Quién recibe el informe final",
requiredSkillsLabel: "Habilidades requeridas",
notScheduledYet: "Aún sin programar",
awaitingAcceptance: "{{name}} · pendiente de aceptación",
notAssignedYet: "Aún no asignado",
assignToName: "Asignar a {{name}}",
someoneElse: "Otra persona",
sourceContractorHint: "{{name}} hizo el trabajo del que surgió este.",
awaitingNote: "Podrás elegir fecha cuando lo acepte",
changeDate: "Cambiar fecha",
planDate: "Elegir fecha",
viewJobLabel: "Ver orden de trabajo {{title}}",
viewJob: "Ver trabajo",
doneBackToRequest: "Listo · Volver a la solicitud",
doneBackToAsset: "Listo · Volver al activo",
doneBackToJobs: "Listo · Volver a órdenes de trabajo",
doneOpenJob: "Listo · Abrir orden de trabajo",
assignToTeamMemberTitle: "Asignar a miembro del equipo",
teamHintNoTeamAsset: "Este activo no está vinculado a ningún equipo; se usa la asignación personal. Puede asignarse la orden de trabajo a usted mismo.",
teamHintNoTeamJob: "No hay ningún equipo establecido en esta orden de trabajo: asignación personal. Puede asignarse la orden de trabajo a usted mismo.",
teamHintUsingTeam: "Utilizando el equipo que gestiona esta orden de trabajo o activo: {{name}}",
teamHintUsingWorkspaceTeam: "Utilizando el equipo del espacio de trabajo vinculado a esta orden de trabajo o activo.",
loadingTeamMembers: "Cargando miembros del equipo…",
retry: "Reintentar",
noTeamMembersTitle: "Aún no hay nadie más en el equipo",
noTeamMembersBody: "Añade a un compañero para asignarle trabajo, o asígnatelo a ti.",
refresh: "Actualizar",
unnamedMember: "Miembro sin nombre",
youSuffix: " (Tú)",
scheduleJobsTogetherTitle: "Programar {{count}} órdenes de trabajo juntas",
planHandoffDateTitle: "¿Cuándo se hará?",
scheduleTogetherText: "Se aplicará la misma fecha, hora y duración estimada a cada orden de trabajo elegible en este lote.",
planHandoffDateText: "Elige el día y la hora en que se hará el trabajo.",
dateLabel: "Fecha",
timeLabel: "Hora",
estimatedDurationLabel: "Duración estimada",
cancel: "Cancelar",
saveForJobs: "Guardar para las {{count}} órdenes de trabajo",
saveDate: "Guardar fecha",
chooseContractorsForQuotes: "Elija contratistas para pedir presupuestos",
assignToContractorTitle: "Asignar al contratista",
addContractor: "Agregar contratista",
error: "Algo salió mal",
failedApplyWorkPathAll: "No se cambiaron todos los trabajos. Comprueba tu conexión e inténtalo de nuevo.",
failedUpdateWorkPath: "No se guardó quién lo hace. Comprueba tu conexión e inténtalo de nuevo.",
failedAssign: "El trabajo no se asignó. Comprueba tu conexión e inténtalo de nuevo.",
failedReleaseFollowUp: "El trabajo de seguimiento no se aprobó. Comprueba tu conexión e inténtalo de nuevo.",
failedScheduleJobsTogether: "Las fechas no se guardaron. Comprueba tu conexión e inténtalo de nuevo.",
failedSchedule: "La fecha no se guardó. Comprueba tu conexión e inténtalo de nuevo.",
noTeamTitle: "Sin equipo para este trabajo",
noTeamBody: "No se pudo saber a qué equipo pertenece este trabajo, así que no se invitó al contratista. Comprueba tu conexión e inténtalo de nuevo.",
assignedTitle: "Asignado, pero el correo no se envió",
assignedInviteFailedBody: "El trabajo es suyo, pero no se pudo enviar el correo de invitación. Avísale tú.",
plannedDateRequiredTitle: "Se requiere fecha planificada",
plannedDateRequiredBody: "Elija una fecha planificada antes de guardar.",
nothingToScheduleTitle: "Nada que programar",
nothingToScheduleBody: "Aún no hay órdenes de trabajo en este lote listas para programarse.",
mustBeAcceptedError: "El trabajo debe aceptarse antes de elegir una fecha.",
},
updates: {
  audienceEveryone: "Todos en este trabajo",
  audienceTeam: "Solo mi equipo",
  failedToPostUpdate: "La actualización no se publicó. Comprueba tu conexión e inténtalo de nuevo.",
  failedToSend: "Tu actualización no se envió. Comprueba tu conexión e inténtalo de nuevo.",
  quickPosted: "Actualización publicada. Aparece en la actividad del trabajo.",
  quick: {
    follow_up_required: {
      note: "Hace falta un trabajo de seguimiento.",
      label: "Necesita un trabajo de seguimiento",
    },
    completed_successfully: {
      note: "El trabajo está hecho.",
      label: "Trabajo hecho",
    },
    additional_issue_found: {
      note: "Encontré otro problema mientras hacía el trabajo.",
      label: "Encontré otro problema",
    },
    awaiting_access: {
      note: "No puedo seguir: esperando acceso al sitio.",
      label: "Esperando acceso",
    },
    awaiting_parts: {
      note: "Esperando piezas para poder seguir con el trabajo.",
      label: "Esperando piezas",
    },
    work_in_progress: {
      note: "Trabajo en curso.",
      label: "Trabajo en curso",
    },
    arrived_on_site: {
      note: "He llegado al sitio.",
      label: "Llegué al sitio",
    },
  },
pageTitle: "Actualizaciones",
jobFallback: "Trabajo",
suggestedUpdateTitle: "Actualización sugerida",
accept: "Aceptar",
expandedUpdate: "Actualización ampliada",
improvedUpdate: "Actualización mejorada",
unableToExpandNote: "No se puede expandir la nota",
unableToImproveNote: "No se puede mejorar la nota",
reviewGeneratedWording: "Revise el texto generado antes de aplicarlo a la actualización.",
photoAccessRequiredTitle: "Se requiere acceso a la foto",
photoAccessRequiredBody: "Permitir el acceso a la biblioteca de fotografías para adjuntar una imagen.",
photoNotSavedTitle: "La foto no fue guardada",
photoNotSavedFallback: "No se pudo guardar esta foto en el dispositivo.",
activityLoadErrorTitle: "No se pudo cargar la actividad. Intentar otra vez.",
tryAgain: "Intentar de nuevo",
loadingActivity: "Cargando actividad",
emptyActivity: "Aún no hay actividad. Las actualizaciones, comentarios, asignaciones y cambios de estado aparecerán aquí.",
internalBadge: "Interno",
savedOnThisDevice: "Guardado en este dispositivo",
showingRecentUpdates: "Mostrando las 100 actualizaciones guardadas más recientes.",
showingSavedActivity: "Mostrando actividad guardada.",
lastRefreshed: "Última actualización {{date}}. Es posible que las fotos necesiten una conexión.",
refreshActivity: "Actualizar actividad",
refreshing: "Actualizando…",
quickUpdates: "Actualizaciones rápidas",
attachPhoto: "Adjuntar una foto",
startUpdatePlaceholder: "Iniciar una actualización...",
jobUpdateLabel: "Actualización de la orden de trabajo",
internalToggleOn: "Solo tu equipo ve esta nota; el contratista no. Toca para mostrarla a todos en este trabajo.",
internalToggleOff: "Todos en este trabajo ven esta nota. Toca para dejarla solo para tu equipo.",
sendUpdate: "Enviar actualización",
improving: "Mejorando...",
improveNote: "Mejorar nota",
expanding: "Añadiendo detalle…",
expandNote: "Añadir detalle con IA",
aiCleanup: "Limpieza con IA",
connectOnceHint: "Conéctese una vez para abrir este espacio de trabajo antes de guardar las actualizaciones.",
openingWorkspace: "Abriendo tu espacio de trabajo…",
updatesSavedOnDevice_one: "{{count}} actualización guardada en este dispositivo.",
updatesSavedOnDevice_other: "{{count}} actualizaciones guardadas en este dispositivo.",
photosSavedOnDevice_one: "{{count}} foto guardada en este dispositivo.",
photosSavedOnDevice_other: "{{count}} fotos guardadas en este dispositivo.",
syncNeedsAttention: "La sincronización necesita atención.",
waitingToSynchronize: "Esperando sincronización.",
reviewSynchronization: "Revisar sincronización",
syncFailed: "No se envió. Comprueba tu conexión e inténtalo de nuevo.",
couldNotSyncActivity: "No se pudo sincronizar la actividad de la orden de trabajo.",
jobPhoto: "Foto de orden de trabajo",
updatesSavedOnDevice_many: "{{count}} actualizaciones guardadas en este dispositivo.",
photosSavedOnDevice_many: "{{count}} fotos guardadas en este dispositivo.",
},
checkRunner: {
jobStarted: "Trabajo iniciado. Toca Completar cuando termines.",
couldNotStartTitle: "No se pudo iniciar la orden de trabajo",
tryAgain: "Inténtalo de nuevo.",
checkFallbackTitle: "Comprobación",
stepWord_one: "paso",
stepWord_other: "pasos",
jobStartsWhenDone: "La orden de trabajo empieza al terminar esta comprobación",
finishPrecheckAndStart: "Finalizar la verificación previa e iniciar la orden de trabajo",
doneBackToJob: "Listo: volver a la orden de trabajo",
stepWord_many: "pasos",
},
quotes: {
inclTax: "impuestos incl.",
declinedLine: "{{name}} lo rechazó: {{reason}}",
pageTitle: "Comparar presupuestos",
inviteOnly: "Solo por invitación",
contractorFallback: "Contratista",
durationNotProvided: "Duración no proporcionada",
priceDeltaVsLowest: "+{{amount}} frente al más bajo",
durationDeltaVsFastest: "+{{duration}} frente al más rápido",
compareQuotesAction: "Comparar presupuestos",
recommendOne: "Recomendar uno",
jobTitleFallback: "Solicitud de presupuesto",
jobNotFound: "Orden de trabajo no encontrada.",
awardQuoteConfirmTitle: "¿Adjudicar a {{name}}?",
priceDurationLine: "{{price}} | {{duration}}",
aiRecommendationFavors: "La recomendación de la IA favorece ahora este presupuesto.",
awardConsequence: "El trabajo pasa a {{name}} de inmediato. Los demás presupuestos se rechazan y se avisa a esos contratistas.",
awarded: "Presupuesto aceptado. El trabajo es ahora de {{name}} y se ha avisado a los demás contratistas que enviaron presupuesto.",
acceptFailedTitle: "No se pudo aceptar el presupuesto",
acceptFailedBody: "El presupuesto no se aceptó. Actualiza esta página para ver si ya se decidió y vuelve a intentarlo.",
rejectFailedTitle: "No se pudo rechazar el presupuesto",
rejectFailedBody: "El presupuesto no se rechazó. Actualiza esta página y vuelve a intentarlo.",
acceptQuoteFallbackMessage: "¿Aceptar este presupuesto y actualizar la orden de trabajo con el contratista, el coste previsto y la duración prevista?",
awardQuoteTitle: "Adjudicar presupuesto",
cancel: "Cancelar",
award: "Adjudicar",
error: "Error",
failedAcceptQuote: "No se pudo aceptar el presupuesto",
rejectQuoteConfirmTitle: "¿Rechazar el presupuesto de {{name}}?",
decisionTrackedNotify: "Se realiza un seguimiento de esta decisión y se puede notificar al contratista.",
rejectQuoteFallbackMessage: "¿Rechazar este presupuesto? Se puede notificar al contratista y se realiza un seguimiento de esta decisión.",
rejectQuoteTitle: "Rechazar presupuesto",
reject: "Rechazar",
failedRejectQuote: "No se pudo rechazar el presupuesto",
aiQuoteIntelligenceTitle: "Análisis de presupuestos con IA",
aiGroundedHint: "Basado solo en los campos de los presupuestos enviados. Revise antes de tomar una decisión final.",
generatingAiInsights: "Generando análisis de IA...",
refreshAiInsights: "Actualizar análisis de IA",
generateAiInsights: "Generar análisis de IA",
lastUpdated: "Última actualización: {{date}}",
comparisonInsightsLabel: "Información comparativa",
notableDifferencesLabel: "Diferencias notables",
bestValueSuggestionLabel: "Sugerencia de mejor valor (asistente)",
suggestedQuote: "Presupuesto sugerido: {{name}}",
noSingleQuoteSuggested: "Aún no se ha sugerido ningún presupuesto (evidencia insuficiente).",
cautionLine: "Precaución: {{caution}}",
confidenceLine: "Confianza: {{confidence}}",
unableToGenerateAiInsights: "No se pudo generar el análisis de IA.",
comparisonSummaryLabel: "Comparar presupuestos",
priceRangeLine: "Rango de precios: {{low}} a {{high}}",
priceDataUnavailable: "Datos de precios no disponibles.",
durationRangeLine: "Rango de duración: {{fast}} a {{slow}}",
durationDataUnavailable: "Datos de duración no disponibles.",
jobContextLabel: "Contexto de orden de trabajo",
assetLine: "Activo: {{name}}",
noLinkedAsset: "Ningún activo vinculado",
locationLine: "Ubicación: {{value}}",
categoryLine: "Categoría: {{value}}",
urgencyLine: "Urgencia: {{value}}",
requestProgressLabel: "Progreso de la solicitud",
inviteSummaryLine: "Invitados: {{invited}} · Enviados: {{submitted}} · Rechazados: {{declined}}",
inviteSummaryPendingSuffix: " · Pendientes: {{pending}}",
responseDeadlineLine: "Fecha límite de respuesta: {{date}}",
targetWindowLine: "Periodo previsto: {{start}} a {{end}}",
budgetLine: "Presupuesto: {{value}}",
scopeLabel: "Ámbito",
noOpenQuotesTitle: "No hay presupuestos abiertos por decidir",
noOpenQuotesBody: "Los contratistas invitados pueden enviar presupuestos. Las decisiones aparecen aquí.",
allDeclinedBody: "Todos los consultados han rechazado. Invite a más contratistas para obtener un precio.",
headerContractor: "Contratista",
headerPrice: "Precio",
headerDuration: "Duración",
headerAvailability: "Disponibilidad",
headerScopeExclusions: "Alcance / exclusiones",
headerAiSummary: "Resumen IA",
scopeResponseMissing: "Falta la respuesta del alcance",
missingLine: "Falta: {{items}}",
completeResponse: "Respuesta completa",
bestPriceChip: "Mejor precio",
fastestChip: "Más rápido",
aiRecommendedChip: "Recomendado por la IA",
runAiInsightsToGenerateSummary: "Ejecute el análisis de IA para generar el resumen.",
acceptedQuoteLabel: "Presupuesto aceptado",
rejectedQuotesLabel: "Presupuestos rechazados",
reasonLine: "Razón: {{reason}}",
selectQuoteTitle: "Seleccione un presupuesto",
selectQuoteBody: "Elija una fila de presupuesto para ver detalles, análisis de IA y decisiones de adjudicación.",
rejecting: "Rechazando...",
awarding: "Adjudicando...",
awardQuoteAction: "Adjudicar presupuesto",
openJob: "Abrir orden de trabajo",
bestPriceAndFastest: "Mejor precio y más rápido",
fastestDuration: "Duración más rápida",
submittedQuoteStatus: "Presupuesto enviado",
applyingDecision: "Aplicando decisión…",
aiIntelligenceLabel: "Análisis de IA",
includedLabel: "incluido",
excludedLabel: "Excluido",
caveatsLabel: "Advertencias",
aiSummaryIncludedLine: "Incluido: {{items}}",
aiSummaryExcludedLine: "Excluido: {{items}}",
aiSummaryCaveatsLine: "Advertencias: {{items}}",
recommendationLabel: "Recomendación",
recommendationValue: "{{name}} ({{confidence}})",
noneFallback: "Ninguno",
whatsIncludedHeading: "Qué incluye",
notProvidedFallback: "No proporcionado",
materialsLabel: "Materiales",
notIncludedFallback: "No incluido",
warrantyLabel: "Garantía",
availabilityRangeArrow: "{{start}} → {{end}}",
exclusionsLabel: "Exclusiones",
evidenceLabel: "Evidencia",
missingInfoLine: "Información faltante: {{items}}",
linkedContextHeading: "Contexto vinculado",
jobLabelKv: "Trabajo",
assetLabelKv: "Activo",
noScopeProvided: "No se proporciona alcance",
requestNotesLabel: "Notas de la solicitud",
noNotesProvided: "No se proporcionaron notas",
inviteMoreContractors: "Invitar a más contratistas",
scopeResponseLine: "Qué cubre: {{value}}",
durationLine: "Duración: {{value}}",
availabilityToLine: "Disponibilidad: {{start}} a {{end}}",
exclusionsLine: "Incluye: {{value}}",
evidenceLine: "Evidencia: {{value}}",
warrantyLine: "Garantía: {{value}}",
attachmentsLine: "Adjuntos: {{count}}",
aiSummaryLabel: "Resumen IA",
fastestDurationChip: "Duración más rápida",
acceptQuote: "Aceptar presupuesto",
},
share: {
  relationshipChangeA11y: "Cambiar su relación con el activo",
  relationshipChange: "Cambiar",
  relationship: "Su relación: {{role}}",
  openJob: "Abrir trabajo",
  editContactDetails: "Editar datos de contacto",
  copyLink: "Copiar enlace",
  emailNotSent: "Compartido, pero el correo no se envió. Copia el enlace para enviarlo tú.",
  checkDetails: "Revisa el contacto, el rol y el correo, y vuelve a tocar Enviar.",
  emailRequired: "Escribe su correo. El enlace al informe se envía allí.",
  roleRequired: "Elige quién es, por ejemplo Solicitante.",
  addEmail: "Añadir correo",
  chooseRole: "Elegir rol",
  chooseContact: "Elegir un contacto",
jobFallback: "Trabajo",
couldNotLoadReport: "No se pudo cargar este informe. Intentar otra vez.",
greetingDefault: "Hola,\n\nLe enviamos el informe de finalización de la orden de trabajo de {{name}}. El trabajo se ha terminado y documentado para sus registros.\n\nGracias.",
loadingReport: "Cargando informe",
tryAgain: "Intentar de nuevo",
jobNotFound: "Orden de trabajo no encontrada",
onlyOwnerCanShare: "Solo el propietario de la orden de trabajo o un miembro del equipo del activo puede compartir el informe de finalización.",
goBack: "Volver",
completeAndVerifyFirst: "Termina este trabajo antes de compartir su informe.",
error: "Error",
jobNotFoundBody: "Orden de trabajo no encontrada.",
notReadyTitle: "No listo",
notReadyBody: "Termina este trabajo antes de compartir su informe.",
checkPhoneTitle: "Revise el número de teléfono",
checkPhoneBody: "Introduzca un número válido para el país seleccionado o deje el teléfono vacío.",
resent: "Reenviado",
sent: "Enviado",
resentBody: "Informe reenviado. Recibirá un correo nuevo con el enlace.",
sentBody: "Informe enviado. Recibirá un correo con un enlace para revisar el trabajo.",
emailErrorLine: "\n\nError: {{error}}",
emailFailedBody: "No se pudo enviar el correo electrónico. Comparta el enlace de revisión manualmente:\n{{link}}{{errorLine}}",
shareCreatedTitle: "Enlace para compartir creado",
shareCreatedBody: "Comparte este enlace:\n{{link}}",
failedToCreateShare: "El informe no se compartió. Comprueba tu conexión e inténtalo de nuevo.",
devLinkWarning: "Los enlaces compartidos utilizan localhost y no funcionarán para los destinatarios. Agregue EXPO_PUBLIC_WEB_APP_URL a su .env (la URL de su aplicación implementada) y reinicie.",
prodLinkWarning: "Aún no se ha configurado un enlace web para compartir para este espacio de trabajo, por lo que es posible que los destinatarios no puedan abrir el enlace del informe. Por favor contacte a su administrador.",
shareToLabel: "Enviar a",
shareToHint: "Pulsa Seleccionar contacto y elige a la persona. Las personas a las que ya lo enviaste aparecen arriba.",
whoCanOpen: "Solo esa persona puede abrir el informe. El enlace de su correo la conecta directamente. Cualquier otra persona que reciba el enlace solo puede pedirle acceso.",
changeContact: "Cambiar contacto",
selectContact: "Seleccionar contacto",
contactFallback: "Contacto",
noEmailOrPhone: "Sin correo electrónico ni teléfono",
shareToContactTitle: "Enviar a",
howToSendLabel: "Cómo enviar",
shareViaLabel: "Compartir vía",
emailMethodLabel: "Correo electrónico",
roleLabel: "Rol *",
recipientNameLabel: "Su nombre (opcional)",
recipientNamePlaceholder: "por ej. Juan Smith",
recipientEmailLabel: "Su correo *",
recipientEmailAria: "Su correo (obligatorio)",
recipientEmailPlaceholder: "cliente@ejemplo.com",
phoneOptionalLabel: "Teléfono (opcional)",
shareStatusLabel: "Ya enviado",
firstSharedLine: "Ya enviado el {{date}}",
lastResharedLine: "Enviado de nuevo el {{date}}",
noResponseByDeadline: "Sin respuesta en la fecha indicada. Pulsa Enviar de nuevo para recordárselo.",
responseDeadlineLabel: "Fecha límite de respuesta (opcional)",
selectDatePlaceholder: "Seleccionar fecha",
messageOptionalLabel: "Mensaje (opcional)",
messagePlaceholder: "Añadir una nota para el destinatario...",
actualCostOnReport: "Costo real en el informe: {{amount}}",
sending: "Enviando…",
resend: "Enviar de nuevo",
send: "Enviar informe",
cancel: "Cancelar",
couldNotShareReportTitle: "No se pudo compartir el informe",
sharingFailedFallback: "Error al compartir. Comprueba tu conexión y vuelve a intentarlo.",
},
requestQuotes: {
includedItemsHeading: "Artículos incluidos:",
excludedOrAssumptionsHeading: "Excluido o supuestos:",
clarificationQuestionsHeading: "Preguntas aclaratorias:",
addNotesFirstTitle: "Agregar notas primero",
addNotesFirstBody: "Escriba o dicte notas y luego use IA para reescribirlas.",
couldNotRewriteNotesTitle: "No se pudieron reescribir notas",
tryAgain: "Inténtelo de nuevo.",
applyAiScopeDraftTitle: "Aplicar borrador de alcance de IA",
applyAiScopeDraftBody: "Ya tienes texto de alcance. ¿Reemplazarlo o añadir el borrador de IA?",
cancel: "Cancelar",
append: "Agregar",
replace: "Reemplazar",
unableToGenerateScopeTitle: "No se puede generar alcance",
selectContractorsTitle: "Seleccionar contratistas",
selectContractorsBody: "Elija al menos un contratista para invitar.",
quoteRequestSent_one: "Solicitud de presupuesto enviada a {{count}} contratista. Te avisaremos cuando lleguen presupuestos. Compáralos desde este trabajo.",
quoteRequestSent_other: "Solicitud de presupuesto enviada a {{count}} contratistas. Te avisaremos cuando lleguen presupuestos. Compáralos desde este trabajo.",
error: "Error",
failedToSendQuoteRequest: "No se pudo enviar la solicitud de presupuesto",
sendFailedTitle: "No se pudo enviar la solicitud de presupuesto",
sendFailedBody: "La solicitud de presupuesto no se envió. Lo que escribiste sigue aquí; vuelve a intentarlo en un momento.",
noEmailNote: "Sin correo, así que no recibirá esto. Añade uno en su ficha de contacto.",
jobNotFound: "Orden de trabajo no encontrada.",
notPrivateQuotesBody: "Este trabajo está pensado para una sola persona. Para pedir precio a varios contratistas, toca Pedir presupuestos.",
notPrivateQuotesLockedBody: "Este trabajo está pensado para una sola persona, así que ya no se pueden pedir presupuestos.",
switchToQuotes: "Pedir presupuestos",
switchingToQuotes: "Cambiando…",
switchFailedTitle: "No se pudo pasar a presupuestos",
switchFailedBody: "El trabajo no se cambió. Vuelve a intentarlo en un momento.",
backToJob: "Volver al trabajo",
goBack: "Volver",
jobTitleFallback: "Solicitud de presupuesto",
pageTitle: "Solicitar presupuestos",
inviteOnly: "Solo por invitación",
inviteTrustedHint: "Invite a contratistas de confianza de su directorio. Esta no es una lista pública.",
scopeDescriptionLabel: "Alcance / descripción",
scopeDescriptionPlaceholder: "¿Qué trabajo se requiere?",
generatingScope: "Generando...",
aiScope: "Redactar con IA",
notesOptionalLabel: "Notas (opcional)",
notesOptionalPlaceholder: "Contexto adicional para los contratistas",
rewriting: "Reescribiendo...",
rewrite: "Reescribir",
aiScopeDraftDetailsTitle: "Detalles del borrador redactado por IA",
includedLine: "Incluido: {{items}}",
excludedLine: "Excluido: {{items}}",
questionsLine: "Preguntas: {{items}}",
responseDeadlineLabel: "Fecha límite de respuesta (opcional)",
respondByPlaceholder: "¿Cuándo deberían responder?",
responseTimeLabel: "Tiempo de respuesta (opcional)",
selectTimePlaceholder: "Seleccionar hora",
targetStartLabel: "Inicio objetivo (opcional)",
earliestStartPlaceholder: "Fecha de inicio más temprana",
targetEndLabel: "Fin previsto (opcional)",
latestEndPlaceholder: "Última fecha de finalización",
estimatedBudgetLabel: "Presupuesto estimado (opcional)",
photosLabel: "Fotos (opcional, máximo 3)",
selectContractorsLabel: "Seleccionar contratistas para invitar *",
selectContractorsHint: "Busque en sus contactos y, si quiere, filtre por habilidad o alcance. No hay nadie preseleccionado.",
requiredSkillsLabel: "Habilidades requeridas",
addOrChangeContractors: "Agregar o cambiar contratistas",
chooseContractors: "Elegir contratistas",
selectedCount: "Seleccionados · {{count}}",
declinedToQuote: "Rechazó enviar presupuesto",
quoteSubmitted: "Presupuesto enviado",
alreadyInvited: "Ya invitado - esperando su respuesta",
removeContact: "Quitar {{name}}",
noContractorsSelected: "Aún no se han seleccionado contratistas.",
creating: "Creando…",
sending: "Enviando…",
everyoneAlreadyInvited: "Todos los seleccionados ya están invitados",
sendToMore_one: "Enviar a {{count}} contratista más",
sendToMore_other: "Enviar a {{count}} contratistas más",
sendTo_one: "Enviar a {{count}} contratista",
sendTo_other: "Enviar a {{count}} contratistas",
chooseContractorsForQuotesTitle: "Elija contratistas para pedir presupuestos",
addContractor: "Agregar contratista",
quoteRequestSent_many: "Solicitud de presupuesto enviada a {{count}} contratistas. Te avisaremos cuando lleguen presupuestos. Compáralos desde este trabajo.",
sendToMore_many: "Enviar a {{count}} contratistas más",
sendTo_many: "Enviar a {{count}} contratistas",
},
quoteInvite: {
brief: {
forClient: "Para {{name}}",
replyBy: "Responder antes del {{date}}",
budget: "Presupuesto {{amount}}",
starts: "Inicio {{date}}",
finishBy: "Terminar antes del {{date}}",
due: "Vence {{date}}",
whatTheyNeed: "Qué necesitan",
where: "Dónde",
route: "Ruta en Google Maps",
photos: "Sus fotos",
},
form: {
title: "Tu presupuesto",
intro: "Di qué cubre tu precio y luego el total. Lo revisas todo antes de enviarlo.",
included: "Qué incluye",
labourOnly: "Solo mano de obra",
labourAndMaterials: "Mano de obra y materiales",
coversLabel: "Qué cubre tu precio",
coversPlaceholder: "p. ej. Suministrar y montar un sofá nuevo de 3 plazas y retirar el viejo",
total: "Precio total",
totalTax: "con todos los impuestos",
totalHelp: "Incluye el IVA y cualquier otro impuesto: es lo que paga el cliente.",
warranty: "Garantía",
warrantyNone: "Ninguna",
warranty3: "3 meses",
warranty6: "6 meses",
warranty12: "12 meses",
warrantyPlaceholder: "O la tuya, p. ej. 2 años en piezas",
takes: "Cuánto tarda",
when: "Cuándo podrías hacerlo",
earliest: "Inicio más temprano",
finishBy: "Terminar antes del",
files: "Fotos o documentos",
note: "Nota para el cliente (opcional)",
notePlaceholder: "Cualquier otra cosa que deban saber",
review: "Revisar y enviar",
needPrice: "Añade el precio total para continuar.",
cantQuote: "No puedo presupuestar este trabajo",
},
review: {
title: "¿Enviar este presupuesto?",
subtitle: "Para {{name}}",
subtitleNoName: "Para el cliente",
total: "Total, con todos los impuestos",
includes: "Incluye",
warranty: "Garantía",
takes: "Tarda",
available: "Disponible",
files: "Adjuntos",
filesCount: "{{n}} adjuntos",
note: "Nota",
send: "Enviar presupuesto",
change: "Cambiar algo",
from: "Desde el {{date}}",
until: "Hasta el {{date}}",
},
declineSheet: {
title: "¿No puedes presupuestar este trabajo?",
subtitle: "Dile a {{name}} por qué. Verán tu motivo.",
subtitleNoName: "Dile al cliente por qué. Verá tu motivo.",
reasonLabel: "¿Por qué no?",
no_availability: "Sin disponibilidad",
outside_area: "Fuera de mi zona",
not_my_work: "No es mi tipo de trabajo",
budget_or_timing: "El presupuesto o los plazos no encajan",
other: "Otro motivo",
noteLabel: "Algo que añadir (opcional)",
noteLabelOther: "Diles por qué",
notePlaceholder: "p. ej. Sin huecos hasta diciembre",
send: "Rechazar el presupuesto",
chooseReason: "Elige un motivo para continuar.",
},
jobFallback: "Trabajo",
loadFailed: "Esta solicitud de presupuesto no se ha cargado. Comprueba tu conexión y vuelve a intentarlo.",
contextLoadFailed: "Los detalles de esta solicitud de presupuesto no se han cargado. Comprueba tu conexión y vuelve a intentarlo.",
notFound: "No encontramos esta solicitud de presupuesto o ya tiene respuesta.",
alreadySent: "Ya enviaste un presupuesto para esta solicitud.",
alreadyDeclined: "Rechazaste esta solicitud de presupuesto.",
closedBody: "Esta solicitud de presupuesto está cerrada. El cliente ya eligió un presupuesto, pasó el plazo o retiró la solicitud.",
deadlinePassed: "El plazo de esta solicitud era {{date}}, así que el cliente ya no puede aceptar presupuestos.",
addNotesFirstTitle: "Añade notas primero",
addNotesFirstBody: "Escribe o dicta notas y luego toca Reescribir.",
rewriteFailedTitle: "No se pudieron reescribir las notas",
rewriteFailedBody: "Vuelve a intentarlo.",
enterPriceTitle: "Indica tu precio",
enterPriceBody: "Escribe el precio total de este trabajo y luego toca Enviar presupuesto.",
durationTitle: "Revisa la duración estimada",
durationBody: "Escribe un número mayor que cero o déjalo en blanco.",
durationPlaceholder: "p. ej. 2",
unit: {
hours: "Horas",
days: "Días",
weeks: "Semanas",
},
dictate: "Dictar",
stop: "Detener",
rewrite: "Reescribir",
rewriting: "Reescribiendo…",
submit: "Enviar presupuesto",
submitting: "Enviando…",
sent: "Presupuesto enviado. Te avisaremos si el cliente lo acepta.",
sendFailedTitle: "No se pudo enviar tu presupuesto",
sendFailedBody: "Tu presupuesto no se envió. Lo que escribiste sigue aquí; vuelve a intentarlo en un momento.",
offlineSend: "Estás sin conexión. Tu presupuesto se guarda en este dispositivo; envíalo cuando vuelvas a tener conexión.",
declineConfirmTitle: "¿Rechazar esta solicitud?",
declineConfirmBody: "Se avisará al cliente de que no vas a enviar presupuesto.",
cancel: "Cancelar",
decline: "Rechazar",
declined: "Solicitud rechazada. Se ha avisado al cliente.",
declineFailedTitle: "No se pudo rechazar",
declineFailedBody: "La solicitud no se rechazó. Vuelve a intentarlo en un momento.",
offlineDecline: "Estás sin conexión. Rechaza la solicitud cuando vuelvas a tener conexión.",
},
contractorNotTold: {
title: "No se avisó a nadie",
body: "{{name}} está asignado pero no tiene correo, así que no se le ha avisado. Añade su correo y vuelve a asignarlo.",
},
created: {
  assignNow_many: "Asignarlos ahora",
  assignNow_other: "Asignarlos ahora",
  assignNow_one: "Asignarlo ahora",
  subtitleAssignedTo: "En Trabajo y asignado a {{names}}.",
  subtitleAssigned: "En Trabajo y asignado.",
  changeWho: "Cambiar quién lo hace",
  subtitleSolo_many: "Están en Trabajo y asignados a ti.",
  subtitleSolo_other: "Están en Trabajo y asignados a ti.",
  subtitleSolo_one: "Está en Trabajo y asignado a ti.",
  subtitle_many: "Están en Trabajo sin asignar. Todavía no se ha avisado a nadie.",
  subtitle_other: "Están en Trabajo sin asignar. Todavía no se ha avisado a nadie.",
  subtitle_one: "Está en Trabajo sin asignar. Todavía no se ha avisado a nadie.",
title_one: "{{count}} trabajo creado",
title_other: "{{count}} trabajos creados",
subtitle: "Están en Trabajo sin asignar. Todavía no se ha avisado a nadie.",
listTitle: "Trabajos creados",
jobLink: "Trabajo {{shortId}}",
backToRequest: "Volver a la solicitud",
backToAsset: "Volver al activo",
backToJobs: "Volver a trabajos",
technicalTitle: "Detalles técnicos",
technicalSummary: "Identificadores completos de trabajo y activo para soporte o integraciones.",
technicalJobIds: "IDs de trabajo",
technicalAssetId: "ID de activo",
showMore: "Mostrar más",
showLess: "Mostrar menos",
title_many: "{{count}} trabajos creados",
},
jobTags: {
urgency: {
low: "Prioridad baja",
medium: "Prioridad media",
high: "Prioridad alta",
urgent: "Urgente",
critical: "Crítica",
},
visibility: {
private: "Privado",
team: "Equipo",
public: "Público",
},
},
assigneeSuggestion: {
similarCompleted_one: "{{count}} orden de trabajo similar completada",
similarCompleted_many: "{{count}} de órdenes de trabajo similares completadas",
similarCompleted_other: "{{count}} órdenes de trabajo similares completadas",
skillMatches_one: "{{count}} orden de trabajo con las mismas habilidades requeridas",
skillMatches_many: "{{count}} de órdenes de trabajo con las mismas habilidades requeridas",
skillMatches_other: "{{count}} órdenes de trabajo con las mismas habilidades requeridas",
completedOnAsset_one: "{{count}} completada en este activo",
completedOnAsset_many: "{{count}} completadas en este activo",
completedOnAsset_other: "{{count}} completadas en este activo",
activeAssignments_one: "{{count}} asignación activa",
activeAssignments_many: "{{count}} de asignaciones activas",
activeAssignments_other: "{{count}} asignaciones activas",
overdue_one: "{{count}} vencida",
overdue_many: "{{count}} vencidas",
overdue_other: "{{count}} vencidas",
separator: ", ",
},
quoteComparisonCopy: {
materialsIncluded: "Materiales incluidos; no se indican exclusiones",
materialsExcluded: "Materiales excluidos: {{details}}",
materialsMissing: "Materiales excluidos; faltan los detalles",
evidenceAttachments_one: "{{count}} adjunto de pruebas",
evidenceAttachments_many: "{{count}} de adjuntos de pruebas",
evidenceAttachments_other: "{{count}} adjuntos de pruebas",
noEvidence: "No hay pruebas adjuntas",
missingScope: "qué cubre el precio",
missingTiming: "plazos",
durationHours_one: "{{count}} hora",
durationHours_many: "{{count}} de horas",
durationHours_other: "{{count}} horas",
durationDays_one: "{{count}} día",
durationDays_many: "{{count}} de días",
durationDays_other: "{{count}} días",
durationWeeks_one: "{{count}} semana",
durationWeeks_many: "{{count}} de semanas",
durationWeeks_other: "{{count}} semanas",
},
};
